(function () {
  // Last-resort fallback only (used when the product has no variants at all).
  // Real swatches always come from the product's own color option values.
  const COLORS = [
    { label: 'Black' },
    { label: 'White' },
    { label: 'Beige' },
    { label: 'Red' },
    { label: 'Pink' },
    { label: 'Blue' },
  ];

  /** Distinct colors (with availability) from a given variant list. */
  function colorsFromVariants(productJson, variants) {
    const colorIndex = findColorOptionIndex(productJson);
    const order = [];
    const byColor = new Map();
    (variants || []).forEach((v) => {
      const label = String([v.option1, v.option2, v.option3][colorIndex] || '').trim();
      if (!label) return;
      if (!byColor.has(label)) {
        order.push(label);
        byColor.set(label, { label, available: false });
      }
      if (v.available) byColor.get(label).available = true;
    });
    return order.map((label) => byColor.get(label));
  }

  /** Get actual color options from product variants for a bundle; each has { label, available }.
      Uses getVariantsForOffer so the color list always matches the offer the merchant set up.
      Falls back to ALL product colors (never a hardcoded language-specific list). */
  function getColorsFromProduct(productJson, bundle) {
    if (!productJson || !productJson.variants || !productJson.variants.length)
      return COLORS.map((c) => ({ label: c.label, available: true }));

    // Swatches must show only CLEAN base colors. Combo variants use a dash-joined
    // color value (e.g. "Black-White"); those must never appear as a swatch — the
    // combo is resolved at add-to-cart via the bundle_combo_lookup metafield.
    const noCombo = (arr) => (arr || []).filter((c) => c && c.label && !c.label.includes('-'));

    // Preferred source: the custom.color_swatches metaobject list ({label, hex}).
    // Availability per color comes from the product's single-color variants.
    if (Array.isArray(productJson.__colorSwatches) && productJson.__colorSwatches.length) {
      const availByLabel = new Map();
      colorsFromVariants(productJson, productJson.variants).forEach((c) => {
        if (c.label && !c.label.includes('-')) availByLabel.set(c.label.toLowerCase(), c.available);
      });
      const list = productJson.__colorSwatches
        .filter((s) => s && s.label && !String(s.label).includes('-'))
        .map((s) => {
          const label = String(s.label);
          const key = label.toLowerCase();
          return {
            label,
            hex: s.hex ? String(s.hex) : '',
            available: availByLabel.has(key) ? availByLabel.get(key) : true,
          };
        });
      if (list.length) return list;
    }

    let list = noCombo(colorsFromVariants(productJson, getVariantsForOffer(productJson, bundle)));
    // If the offer filter produced nothing (offer is combo-only, or value mismatch),
    // fall back to every clean color the product actually has.
    if (!list.length) list = noCombo(colorsFromVariants(productJson, productJson.variants));
    return list.length ? list : COLORS.map((c) => ({ label: c.label, available: true }));
  }

  /** Normalize an offer option value for tolerant comparison (whitespace, nbsp, case). */
  function normOffer(s) {
    return String(s == null ? '' : s)
      .replace(/ /g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  /** Current bundle key from the hidden input (single | one_plus_one | two_plus_one). */
  function getBundleKeyFromRoot(root) {
    const bi = root && root.querySelector('input[name="properties[_bundle]"]');
    return bi ? String(bi.value || 'single') : 'single';
  }

  // { Color: firstGalleryImageUrl } for the FIRST offer, emitted by bundle-selector.liquid
  // as <script class="bundle-gallery-first-images">. Used for the bundle-item thumbnail
  // when the "Bundle thumbnails from variant gallery metafield" setting is on.
  function getGalleryThumbs(root) {
    const picker = (root && root.closest && root.closest('.bundle-picker')) || root;
    const s =
      (picker && picker.querySelector('script.bundle-gallery-first-images')) ||
      document.querySelector('.bundle-picker script.bundle-gallery-first-images') ||
      document.querySelector('script.bundle-gallery-first-images');
    if (!s || !s.textContent || !s.textContent.trim()) return null;
    try {
      const m = JSON.parse(s.textContent);
      return m && typeof m === 'object' ? m : null;
    } catch (e) {
      return null;
    }
  }

  /**
   * Whole-bundle totals (in cents) for a combo offer, read from the
   * bundle_combo_lookup metafield (_offer_prices / _offer_compare). Needed because
   * the combo variants live BEYOND the 250-variant window, so their price can't be
   * read from productJson.variants. Tolerant offer-value match. Returns null if absent.
   */
  function getComboOfferTotals(productJson, offerValue) {
    const lk = productJson && productJson.__comboLookup;
    if (!lk || !offerValue) return null;
    const prices = lk._offer_prices || {};
    const compares = lk._offer_compare || {};
    let priceCents = prices[offerValue];
    let compareCents = compares[offerValue];
    if (priceCents == null) {
      const want = normOffer(offerValue);
      for (const k in prices) if (normOffer(k) === want) { priceCents = prices[k]; break; }
      for (const k in compares) if (normOffer(k) === want) { compareCents = compares[k]; break; }
    }
    if (priceCents == null) return null;
    return { priceCents: Number(priceCents), compareCents: Number(compareCents || 0) };
  }

  /** First real color of the product (prefers an available one). Replaces the
      old hardcoded 'Schwarz' default so it works with ANY color naming/language. */
  function getDefaultColor(root, bundle) {
    const productJson = getProductJson(root);
    if (!bundle) {
      const bi = root.querySelector('input[name="properties[_bundle]"]');
      bundle = bi ? bi.value : 'single';
    }
    const colors = getColorsFromProduct(productJson, bundle) || [];
    const avail = colors.find((c) => c.available);
    return (avail && avail.label) || (colors[0] && colors[0].label) || '';
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function routesRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function getSelectedSizeFromForm(productJson, form) {
    const vid = getCurrentVariantIdFromForm(form);
    if (!vid) return '';

    const v = (productJson.variants || []).find((x) => Number(x.id) === Number(vid));
    if (!v) return '';

    const sizeIdx = findSizeOptionIndex(productJson);
    return ([v.option1, v.option2, v.option3][sizeIdx] || '').trim();
  }
  function injectCssOnce() {
    if (document.getElementById('bundle-fixed-swatches-css')) return;

    const style = document.createElement('style');
    style.id = 'bundle-fixed-swatches-css';
    style.textContent = `
    /* ONLY layout for popup combo rows */
    .bundle-item--popup-11 .bundle-fixed-swatches,
    .bundle-item--popup-21 .bundle-fixed-swatches {
      display:flex;
      gap:12px;
      flex-wrap:wrap;
      align-items:center;
      margin-top:14px;
    }

    /* Do NOT override .bundle-fixed-swatch and .bundle-fixed-swatch__dot here.
       Global styles will apply consistently. */
  `;
    document.head.appendChild(style);
  }
  function updateUnlockUI(root, bundle) {
    qsa(root, '.bundle-picker__unlock-msg').forEach((m) => m.classList.remove('is-active'));

    const shipping = qs(root, '.bundle-unlock[data-unlock="shipping"]');
    const gift = qs(root, '.bundle-unlock[data-unlock="gift"]');

    shipping && shipping.classList.remove('is-active');
    gift && gift.classList.remove('is-active');
    const gifts = root.querySelectorAll('[data-unlock="gift"]');
    const shippings = root.querySelectorAll('[data-unlock="shipping"]');

    // Safety reset: hide all gift blocks first
    gifts.forEach((g) => g.classList.add('hidden'));
    // Safety reset: hide all shipping blocks first
    shippings.forEach((g) => g.classList.add('hidden'));

    if (bundle === 'single') {
      qs(root, '.bundle-picker__unlock-msg[data-msg="none"]')?.classList.add('is-active');

      // Show ONLY the 2+1 card
      gifts[0]?.classList.remove('hidden');
      shippings[0]?.classList.remove('hidden');
    } else if (bundle === 'one_plus_one') {
      qs(root, '.bundle-picker__unlock-msg[data-msg="shipping"]')?.classList.add('is-active');
      shippings[0]?.classList.add('hidden');
      shippings[1]?.classList.remove('hidden');
      shippings[1]?.classList.add('is-active');

      // Show ONLY the 2+1 card
      gifts[0]?.classList.remove('hidden');
    } else if (bundle === 'two_plus_one') {
      qs(root, '.bundle-picker__unlock-msg[data-msg="all"]')?.classList.add('is-active');
      shippings[0]?.classList.add('hidden');
      shippings[1]?.classList.remove('hidden');
      shippings[1]?.classList.add('is-active');

      // Show ONLY the real gift product card
      gifts[0]?.classList.add('hidden');
      gifts[1]?.classList.remove('hidden');
      gifts[1]?.classList.add('is-active');
    }

    const giftBlock = qs(root, '.bundle-gift-variant');
    if (giftBlock) giftBlock.hidden = bundle !== 'two_plus_one';
  }

  /** Parse single-line text price (e.g. "29,99" or "29.99 €") to number. */
  function parsePriceFromMetafield(str) {
    if (str == null || String(str).trim() === '') return NaN;
    const cleaned = String(str)
      .replace(',', '.')
      .replace(/[^\d.]/g, '');
    const num = parseFloat(cleaned);
    return Number.isFinite(num) ? num : NaN;
  }

  /** Format number as price string (e.g. "29,99 €"). */
  function formatPrice(num) {
    if (num == null || !Number.isFinite(num)) return '';
    return num.toFixed(2).replace('.', ',') + ' €';
  }

  /** Format variant price in cents to money string (e.g. "29,99 €"). */
  function formatMoneyFromCents(cents) {
    if (cents == null || !Number.isFinite(cents)) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function applyPopupSizeFilter(root, bundle) {
    if (root.dataset.popup !== 'true') return;
    const productJson = getProductJson(root);
    if (!productJson) return;
    const variantRoot = root.querySelector('[data-popup-variant]');
    if (!variantRoot) return;
    const availableSizes = getAvailableSizesForOffer(productJson, bundle);
    variantRoot.querySelectorAll('.popup-variant__label').forEach(function (label) {
      const sizeName = (label.textContent || '').trim();
      const available = availableSizes.length === 0 || availableSizes.includes(sizeName);
      label.style.display = available ? '' : 'none';
      label.classList.toggle('popup-variant__label--disabled', !available);
      const forId = label.getAttribute('for');
      if (forId) {
        const radio = variantRoot.querySelector('input#' + CSS.escape(forId));
        if (radio) radio.disabled = !available;
      }
    });
  }

  function updatePopupPriceForBundle(root, bundle, forceMetafields) {
    if (root.dataset.popup !== 'true') return;
    const scope = root.closest('.product-popup-modal') || root.closest('.product-info') || root;
    let priceList = scope.querySelector('price-list');
    if (!priceList) {
      const productInfo = root.closest('.product-info');
      if (!productInfo) return;
      const bundleBlockItem = root.closest('.product-info__block-item');
      const priceBlockItem =
        productInfo.querySelector('.product-info__block-item[data-block-type="price"]') ||
        productInfo.querySelector('.product-info__block-item[data-block-type="popup-price"]') ||
        (bundleBlockItem && bundleBlockItem.previousElementSibling);
      if (!priceBlockItem) return;
      const priceWrap = priceBlockItem.querySelector('.product-info__price');
      priceList = priceWrap && priceWrap.querySelector('price-list');
    }
    if (!priceList) return;
    const compareEl = priceList.querySelector('compare-at-price');
    const saleEl = priceList.querySelector('sale-price');
    if (!saleEl) return;

    let oldStr = '';
    let newStr = '';

    let variant = null;
    if (!forceMetafields) {
      const form = findProductForm(root);
      const productJson = getProductJson(root);
      const variantIdInput = form && form.querySelector('input[name="id"]');
      const variantId = variantIdInput ? (variantIdInput.value || '').trim() : '';
      if (productJson && variantId && productJson.variants && productJson.variants.length) {
        variant = productJson.variants.find((v) => String(v.id) === String(variantId));
      }
    }

    if (variant && Number.isFinite(variant.price)) {
      newStr = formatMoneyFromCents(variant.price);
      if (variant.compare_at_price != null && Number(variant.compare_at_price) > 0) {
        oldStr = formatMoneyFromCents(variant.compare_at_price);
      }
    } else {
      const variantIdInput = root.closest('.product-popup-modal')
        ? findProductForm(root) && findProductForm(root).querySelector('input[name="id"]')
        : null;
      const noVariantInPopup = variantIdInput && !(variantIdInput.value || '').trim();
      if (noVariantInPopup) {
        newStr = '';
        oldStr = '';
      } else {
        if (bundle === 'single') {
          oldStr = (root.dataset.bundle1PriceTop || '').trim();
          newStr = (root.dataset.bundle1PriceBottom || '').trim();
        } else if (bundle === 'one_plus_one') {
          oldStr = (root.dataset.bundle2Compare || '').trim();
          newStr = (root.dataset.bundle2Each || '').trim();
        } else if (bundle === 'two_plus_one') {
          oldStr = (root.dataset.bundle3Compare || '').trim();
          newStr = (root.dataset.bundle3Each || '').trim();
        }
      }
    }

    if (compareEl) {
      const srOnly = compareEl.querySelector('.sr-only');
      compareEl.innerHTML = srOnly ? srOnly.outerHTML + (oldStr || '') : oldStr || '';
      compareEl.style.display = oldStr ? '' : 'none';
    }
    const saleContent = newStr || '';
    const srOnly = saleEl.querySelector('.sr-only');
    saleEl.innerHTML = srOnly ? srOnly.outerHTML + saleContent : saleContent;
  }

  function ensureHidden(root, formId, name, value) {
    let inp = root.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = name;
      if (formId) inp.setAttribute('form', formId);
      root.appendChild(inp);
    }
    inp.value = value;
  }

  function ensureHiddenColorProperties(root, formId, count) {
    const def = getDefaultColor(root);
    for (let i = 1; i <= count; i++) {
      const name = `properties[_bundle_color_${i}]`;
      if (!root.querySelector(`input[name="${CSS.escape(name)}"]`)) {
        ensureHidden(root, formId, name, def);
      }
    }
  }

  /**
   * Get image URL for a variant — same as product-popup-card: image comes from the variant's assigned image.
   * 1) variant.image_id → find in product.images (canonical variant→image in Shopify)
   * 2) same id in product.media → preview_image.url/src
   * 3) variant.featured_media.preview_image (Liquid uses this)
   * 4) variant.featured_image
   * 5) first product image
   */
  function getVariantImageUrl(productJson, variant) {
    if (!variant || !productJson) return null;

    const vid =
      variant.image_id != null ? variant.image_id : variant.featured_media?.id ?? variant.featured_image?.id;
    if (vid != null) {
      if (productJson.images && productJson.images.length) {
        const byId = productJson.images.find(
          (im) => Number(im.id) === Number(vid) || String(im.id) === String(vid)
        );
        if (byId) {
          const u = byId.src || byId.url;
          if (u) return u;
        }
      }
      if (productJson.media && productJson.media.length) {
        const media = productJson.media.find((m) => Number(m.id) === Number(vid) || String(m.id) === String(vid));
        if (media) {
          const pi = media.preview_image || media;
          if (pi && (pi.url || pi.src)) return pi.url || pi.src;
          if (media.src || media.url) return media.src || media.url;
        }
      }
    }

    const prev = variant.featured_media?.preview_image;
    if (prev && (prev.url || prev.src)) return prev.url || prev.src;
    const img = variant.featured_image || variant.featured_media;
    if (img && (img.src || img.url)) return img.src || img.url;

    if (productJson.images && productJson.images.length) {
      const first = productJson.images[0];
      return first.src || first.url || first;
    }
    return null;
  }

  function setBundleColor(root, rowIndex, colorName) {
    const rows = qsa(root, '.bundle-item');
    const row = rows[rowIndex];

    if (row) {
      row.querySelectorAll('.bundle-fixed-swatch').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.color === colorName ? 'true' : 'false');
      });
      const label = row.querySelector('.bundle-item__color');
      if (label) label.textContent = colorName;

      const productJson = getProductJson(root);
      const form = findProductForm(root);
      const currentVariantId = form ? getCurrentVariantIdFromForm(form) : null;
      const currentVariant =
        productJson && currentVariantId
          ? (productJson.variants || []).find((v) => Number(v.id) === Number(currentVariantId))
          : null;
      if (productJson) {
        // Resolve the size to use (bundle size UI -> form -> current variant).
        let size = (qs(root, '.bundle-items__size')?.textContent || '').trim();
        if (!size) size = getSelectedSizeFromForm(productJson, form);
        if (!size && currentVariant) {
          const sizeIdx = findSizeOptionIndex(productJson);
          size = [currentVariant.option1, currentVariant.option2, currentVariant.option3][sizeIdx] || '';
        }

        // Resolve the variant WITHIN THE CURRENT BUNDLE'S OFFER, so the cart gets
        // the right variant id and the right price for this offer (single / 1+1 / 2+1).
        const bundleKey = getBundleKeyFromRoot(root);
        let variant = findVariantByOfferSizeColor(productJson, bundleKey, size, colorName);

        // Fallbacks: same offer without size, then keep the main variant's options
        // (offer + size) and just swap color, then any variant by color+size.
        if (!variant) variant = findVariantByOfferSizeColor(productJson, bundleKey, '', colorName);
        if (!variant && currentVariant) {
          const optionCount = (productJson.options || []).length || 1;
          const currentOptions = [currentVariant.option1, currentVariant.option2, currentVariant.option3].slice(
            0,
            optionCount
          );
          const colorIndex = findColorOptionIndex(productJson);
          const wanted = currentOptions.slice();
          wanted[colorIndex] = colorName;
          variant = findVariantByOptions(productJson, wanted);
        }
        if (!variant) {
          variant = findVariantByColorAndSize(productJson, colorName, size);
        }

        const vidName = `properties[_bundle_variant_id_${rowIndex + 1}]`;
        const vidInput = root.querySelector(`input[name="${CSS.escape(vidName)}"]`);
        if (vidInput) vidInput.value = variant ? String(variant.id) : '';

        if (variant && variant.id) {
          const bundleInput = qs(root, 'input[name="properties[_bundle]"]');
          const formId = bundleInput?.getAttribute('form') || null;

          const vidName = `properties[_bundle_variant_id_${rowIndex + 1}]`;
          ensureHidden(root, formId, vidName, String(variant.id));
        }

        if (variant && rowIndex === 0) {
          // On the very first render we keep the MAIN product variant/price untouched
          // (initial single-price display). Only skip that main-form sync — NOT the row
          // thumbnail below, otherwise row 0 keeps the product featured image while the
          // other rows show the resolved variant image (mismatched first render).
          const lockInitialVariant =
            root.dataset.initialSinglePrice === 'true' && root.dataset.initialSinglePriceUnlocked !== '1';
          if (!lockInitialVariant) {
            const mainForm = findProductForm(root);
            const idInput = mainForm && mainForm.querySelector('input[name="id"]');
            if (idInput && String(idInput.value) !== String(variant.id)) {
              idInput.value = String(variant.id);
              idInput.dispatchEvent(new Event('change', { bubbles: true }));
              setVariantInUrl(variant.id);
            }
          }
        }

        let imgUrl = null;
        // "Bundle thumbnails from variant gallery": use the first custom.product_gallery_img
        // photo of this color (first offer); fall back to the variant image below.
        if (root.dataset.thumbFromGallery === 'true' && colorName) {
          const gmap = getGalleryThumbs(root);
          if (gmap && gmap[colorName]) imgUrl = gmap[colorName];
        }
        if (root.dataset.popup === 'true') {
          if (!imgUrl && variant) imgUrl = getPopupImageUrl(root, variant);
        } else {
          if (!imgUrl && variant) imgUrl = getPopupImageUrl(root, variant);
          if (!imgUrl && variant) imgUrl = getVariantImageUrl(productJson, variant);
          if (!imgUrl && colorName) imgUrl = getImageUrlForColor(productJson, colorName);
        }
        const thumbEl = row.querySelector('.bundle-item__img');
        if (thumbEl && imgUrl) {
          const url = typeof imgUrl === 'string' ? imgUrl : imgUrl.src || imgUrl.url;
          if (url) {
            const img = thumbEl.querySelector('img');
            if (img) img.src = url;
            else thumbEl.innerHTML = `<img src="${url}" alt="" loading="lazy">`;
          }
        }
      }
    }

    const colorInputName = 'properties[_bundle_color_' + (rowIndex + 1) + ']';
    const prop = root.querySelector('input[name="' + CSS.escape(colorInputName) + '"]');
    if (prop) prop.value = colorName;

    const header = qs(root, '.bundle-items__colors');
    if (header) {
      const values = rows.map(
        (_, i) =>
          root.querySelector('input[name="' + CSS.escape('properties[_bundle_color_' + (i + 1) + ']') + '"]')
            ?.value || '—'
      );
      header.textContent = values.join(', ');
    }

    // Notify listeners on ANY row's color change (row 0 also fires a variant change,
    // but rows 1/2 don't) so stock/preorder recomputes against ALL selected colors.
    try {
      root.dispatchEvent(new CustomEvent('bundle:colorchange', { bubbles: true, detail: { rowIndex } }));
    } catch (e) {}
  }

  function findOfferOptionIndex(productJson) {
    const names = (productJson.options || []).map((o) => (typeof o === 'string' ? o : o?.name)).filter(Boolean);
    for (let i = 0; i < names.length; i++) {
      const n = String(names[i]).toLowerCase();
      if (n.includes('offer') || n.includes('bundle') || n.includes('pack')) return i;
    }
    return -1;
  }

  function getVariantIdFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const v = params.get('variant');
      if (v && /^\d+$/.test(String(v).trim())) return String(v).trim();
    } catch (e) {}
    return null;
  }

  function setVariantInUrl(variantId) {
    try {
      const url = new URL(window.location.href);
      const current = url.searchParams.get('variant');
      if (variantId) {
        const next = String(variantId);
        if (current === next) return;
        url.searchParams.set('variant', next);
      } else {
        if (!current) return;
        url.searchParams.delete('variant');
      }
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function getVariantsForOffer(productJson, bundleKey) {
    if (!productJson || !productJson.variants || !productJson.variants.length) return [];
    const offerIndex = findOfferOptionIndex(productJson);
    if (offerIndex < 0) return productJson.variants;
    const offer1 = normOffer(getOffer1Plus1Value(productJson));
    const offer21 = normOffer(getOffer2Plus1Value(productJson));
    const variants = productJson.variants || [];
    const ovOf = (v) => normOffer([v.option1, v.option2, v.option3][offerIndex]);
    if (bundleKey === 'one_plus_one' && offer1) {
      return variants.filter((v) => ovOf(v) === offer1);
    }
    if (bundleKey === 'two_plus_one' && offer21) {
      return variants.filter((v) => ovOf(v) === offer21);
    }
    if (bundleKey === 'single') {
      return variants.filter((v) => {
        const ov = ovOf(v);
        return ov && ov !== offer1 && ov !== offer21;
      });
    }
    return variants;
  }

  function getAvailableSizesForOffer(productJson, bundleKey) {
    const filtered = getVariantsForOffer(productJson, bundleKey);
    const sizeIndex = findSizeOptionIndex(productJson);
    const set = new Set();
    filtered.forEach((v) => {
      const s = String([v.option1, v.option2, v.option3][sizeIndex] || '').trim();
      if (s) set.add(s);
    });
    return Array.from(set);
  }

  function getAvailableColorsForOffer(productJson, bundleKey) {
    const filtered = getVariantsForOffer(productJson, bundleKey);
    const colorIndex = findColorOptionIndex(productJson);
    const set = new Set();
    filtered.forEach((v) => {
      const c = String([v.option1, v.option2, v.option3][colorIndex] || '').trim();
      if (c) set.add(c);
    });
    return Array.from(set);
  }

  function findVariantByOfferSizeColor(productJson, bundleKey, sizeName, colorName) {
    const filtered = getVariantsForOffer(productJson, bundleKey);
    const sizeIndex = findSizeOptionIndex(productJson);
    const colorIndex = findColorOptionIndex(productJson);
    let list = filtered;
    if (sizeName) {
      list = list.filter(
        (v) => String([v.option1, v.option2, v.option3][sizeIndex] || '').trim() === String(sizeName).trim()
      );
    }
    if (colorName) {
      list = list.filter(
        (v) =>
          String([v.option1, v.option2, v.option3][colorIndex] || '')
            .trim()
            .toLowerCase() === String(colorName).trim().toLowerCase()
      );
    }
    return list[0] || null;
  }

  function getFirstAvailableVariantForOffer(productJson, bundleKey) {
    const filtered = getVariantsForOffer(productJson, bundleKey);
    if (!filtered.length) return null;
    const available = filtered.find((v) => v.available === true);
    return available || filtered[0] || null;
  }

  function getOffer1Plus1Value(productJson) {
    // Position-based: 2nd offer value = 1+1, independent of its NAME.
    if (productJson && Array.isArray(productJson.__offerOrder) && productJson.__offerOrder[1]) {
      return String(productJson.__offerOrder[1]).trim();
    }
    // Legacy fallback: detect by name (products still using "1+1" values).
    const offerIndex = findOfferOptionIndex(productJson);
    if (offerIndex < 0) return null;
    const seen = new Set();
    (productJson.variants || []).forEach((v) => {
      const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
      if (ov) seen.add(ov);
    });
    return Array.from(seen).find((ov) => /1\+1|1\s*\+\s*1/i.test(ov)) || null;
  }

  function parseComboLabel(label) {
    const s = String(label || '').trim();
    if (!s) return { c1: 'Schwarz', c2: 'Schwarz' };
    const twoMatch = s.match(/^2\s*(.+)$/i);
    if (twoMatch) {
      const c = twoMatch[1].trim();
      return { c1: c, c2: c };
    }
    const dash = s.indexOf('-');
    if (dash > 0) {
      const c1 = s.slice(0, dash).trim();
      const c2 = s.slice(dash + 1).trim();
      if (c1 && c2) return { c1, c2 };
    }
    const bySpace = s.split(/\s+/).filter(Boolean);
    if (bySpace.length >= 2) return { c1: bySpace[0], c2: bySpace[1] };
    return { c1: s, c2: s };
  }

  function getPopup11CombosFromProduct(productJson) {
    if (!productJson || !productJson.variants || !productJson.variants.length) return [];
    const offer1 = getOffer1Plus1Value(productJson);
    if (!offer1) return [];
    const offerIndex = findOfferOptionIndex(productJson);
    const colorIndex = findColorOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const filtered = productJson.variants.filter((v) => {
      const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
      return ov === offer1;
    });
    const sizesSet = new Set();
    filtered.forEach((v) => {
      const sz = String([v.option1, v.option2, v.option3][sizeIndex] || '').trim();
      if (sz) sizesSet.add(sz);
    });
    const sizes = Array.from(sizesSet);
    const labelsOrder = [];
    const labelsSeen = new Set();
    filtered.forEach((v) => {
      const farbe = String([v.option1, v.option2, v.option3][colorIndex] || '').trim();
      if (farbe && !labelsSeen.has(farbe)) {
        labelsSeen.add(farbe);
        labelsOrder.push(farbe);
      }
    });
    return labelsOrder.map((label) => {
      const { c1, c2 } = parseComboLabel(label);
      let available = false;
      for (let i = 0; i < sizes.length; i++) {
        const vv = findVariantByFarbeLabelSizeOffer(productJson, label, sizes[i], offer1);
        if (vv && vv.available) {
          available = true;
          break;
        }
      }
      return { id: label, label, c1, c2, available };
    });
  }

  function getOffer2Plus1Value(productJson) {
    // Position-based: 3rd offer value = 2+1, independent of its NAME.
    if (productJson && Array.isArray(productJson.__offerOrder) && productJson.__offerOrder[2]) {
      return String(productJson.__offerOrder[2]).trim();
    }
    // Legacy fallback: detect by name (products still using "2+1" values).
    const offerIndex = findOfferOptionIndex(productJson);
    if (offerIndex < 0) return null;
    const seen = new Set();
    (productJson.variants || []).forEach((v) => {
      const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
      if (ov) seen.add(ov);
    });
    return Array.from(seen).find((ov) => /2\+1|2\s*\+\s*1/i.test(ov)) || null;
  }

  function getFirstVariantIdForBundle(productJson, bundleKey) {
    if (!productJson || !productJson.variants || !productJson.variants.length) return null;
    const offerIndex = findOfferOptionIndex(productJson);
    if (offerIndex < 0) return productJson.variants[0]?.id ?? null;
    const offer1 = getOffer1Plus1Value(productJson);
    const offer21 = getOffer2Plus1Value(productJson);
    const variants = productJson.variants || [];
    if (bundleKey === 'one_plus_one' && offer1) {
      const v = variants.find(
        (v) => String([v.option1, v.option2, v.option3][offerIndex] || '').trim() === offer1
      );
      return v ? v.id : null;
    }
    if (bundleKey === 'two_plus_one' && offer21) {
      const v = variants.find(
        (v) => String([v.option1, v.option2, v.option3][offerIndex] || '').trim() === offer21
      );
      return v ? v.id : null;
    }
    if (bundleKey === 'single') {
      const v = variants.find((v) => {
        const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
        return ov && ov !== offer1 && ov !== offer21;
      });
      return v ? v.id : variants[0]?.id ?? null;
    }
    return variants[0]?.id ?? null;
  }

  function parseComboLabel21(label) {
    const s = String(label || '').trim();
    if (!s) return { c1: 'Schwarz', c2: 'Schwarz', c3: 'Schwarz' };
    const threeMatch = s.match(/^3\s*(.+)$/i);
    if (threeMatch) {
      const c = threeMatch[1].trim();
      return { c1: c, c2: c, c3: c };
    }
    const twoMatch = s.match(/^2\s*(.+?)\s*-\s*(.+)$/i);
    if (twoMatch) {
      const c1 = twoMatch[1].trim();
      const c2 = twoMatch[2].trim();
      return { c1, c2: c1, c3: c2 };
    }
    const byDash = s
      .split('-')
      .map((p) => p.trim())
      .filter(Boolean);
    if (byDash.length >= 3) return { c1: byDash[0], c2: byDash[1], c3: byDash[2] };
    if (byDash.length === 2) return { c1: byDash[0], c2: byDash[0], c3: byDash[1] };
    const bySpace = s.split(/\s+/).filter(Boolean);
    if (bySpace.length >= 3) return { c1: bySpace[0], c2: bySpace[1], c3: bySpace[2] };
    if (bySpace.length === 2) return { c1: bySpace[0], c2: bySpace[0], c3: bySpace[1] };
    return { c1: s, c2: s, c3: s };
  }

  function getPopup21CombosFromProduct(productJson) {
    if (!productJson || !productJson.variants || !productJson.variants.length) return [];
    const offer21 = getOffer2Plus1Value(productJson);
    if (!offer21) return [];
    const offerIndex = findOfferOptionIndex(productJson);
    const colorIndex = findColorOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const filtered = productJson.variants.filter((v) => {
      const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
      return ov === offer21;
    });
    const sizesSet = new Set();
    filtered.forEach((v) => {
      const sz = String([v.option1, v.option2, v.option3][sizeIndex] || '').trim();
      if (sz) sizesSet.add(sz);
    });
    const sizes = Array.from(sizesSet);
    const labelsOrder = [];
    const labelsSeen = new Set();
    filtered.forEach((v) => {
      const farbe = String([v.option1, v.option2, v.option3][colorIndex] || '').trim();
      if (farbe && !labelsSeen.has(farbe)) {
        labelsSeen.add(farbe);
        labelsOrder.push(farbe);
      }
    });
    return labelsOrder.map((label) => {
      const { c1, c2, c3 } = parseComboLabel21(label);
      let available = false;
      for (let i = 0; i < sizes.length; i++) {
        const vv = findVariantByFarbeLabelSizeOffer(productJson, label, sizes[i], offer21);
        if (vv && vv.available) {
          available = true;
          break;
        }
      }
      return { id: label, label, c1, c2, c3, available };
    });
  }

  function getColorHex(colorName) {
    const c = String(colorName || '')
      .trim()
      .toLowerCase();
    if (c.includes('schwarz') || c === 'black') return '#000';
    if (c.includes('weiß') || c.includes('weiss') || c === 'white') return '#fff';
    if (c.includes('beige')) return '#e7cfb3';
    if (c.includes('braun') || c.includes('brown')) return '#975d48';
    if (c.includes('grau') || c.includes('grey') || c.includes('gray')) return '#808080';
    if (c.includes('blau') || c.includes('blue')) return '#0000ff';
    if (c.includes('rot') || c.includes('red')) return '#ff0000';
    if (c.includes('grün') || c.includes('gruen') || c.includes('green')) return '#008000';
    if (c.includes('gelb') || c.includes('yellow')) return '#ffff00';
    if (c.includes('pink')) return '#db4684';
    if (c.includes('navy')) return '#000080';
    if (c.includes('multicolor') || c.includes('multi-color') || c.includes('multi color')) return null;
    return '#ccc';
  }

  function findVariantByColorSizeOffer(productJson, color, size, offerLabel) {
    const variants = productJson.variants || [];
    const colorIndex = findColorOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const offerIndex = findOfferOptionIndex(productJson);

    const c = String(color).trim().toLowerCase();
    const s = String(size).trim();
    const o = String(offerLabel).trim().toLowerCase();

    return (
      variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        const vc = String(opts[colorIndex] || '')
          .trim()
          .toLowerCase();
        const vs = String(opts[sizeIndex] || '').trim();
        const vo =
          offerIndex >= 0
            ? String(opts[offerIndex] || '')
                .trim()
                .toLowerCase()
            : '';
        return vc === c && vs === s && (offerIndex < 0 || vo === o);
      }) || null
    );
  }

  function findVariant11(productJson, color, size, offer1) {
    if (offer1) {
      const v = findVariantByColorSizeOffer(productJson, color, size, offer1);
      if (v) return v;
    }
    return findVariantByColorAndSize(productJson, color, size);
  }

  function getDefaultSizeForPopup11(root, productJson) {
    let size = (qs(root, '.bundle-items__size')?.textContent || '').trim();
    if (size) return size;
    const form = findProductForm(root);
    if (form) size = getSelectedSizeFromForm(productJson, form);
    if (size) return size;
    const offer1 = getOffer1Plus1Value(productJson);
    if (!offer1) return '';
    const offerIndex = findOfferOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const first = (productJson.variants || []).find((v) => {
      const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
      return ov === offer1;
    });
    return first ? String([first.option1, first.option2, first.option3][sizeIndex] || '').trim() : '';
  }

  function findVariant21(productJson, color, size, offer21) {
    if (offer21) {
      const v = findVariantByColorSizeOffer(productJson, color, size, offer21);
      if (v) return v;
    }
    return findVariantByColorAndSize(productJson, color, size);
  }

  function findVariantByFarbeLabelSizeOffer(productJson, farbeLabel, size, offerValue) {
    const colorIndex = findColorOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const offerIndex = findOfferOptionIndex(productJson);
    const variants = productJson.variants || [];
    return (
      variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        const farbe = String(opts[colorIndex] || '').trim();
        const sz = String(opts[sizeIndex] || '').trim();
        const offer = offerIndex >= 0 ? String(opts[offerIndex] || '').trim() : '';
        return farbe === farbeLabel && sz === size && (offerIndex < 0 || offer === offerValue);
      }) || null
    );
  }

  /** All orderings of an array (mirrors the DE custom-bundle.liquid combo logic). */
  function getPermutations(arr) {
    if (arr.length <= 1) return [arr];
    const result = [];
    arr.forEach(function (el, i) {
      const rest = arr.slice(0, i).concat(arr.slice(i + 1));
      getPermutations(rest).forEach(function (p) {
        result.push([el].concat(p));
      });
    });
    return result;
  }

  /**
   * 250-variant bypass: resolve the single combo variant id from the
   * custom.bundle_combo_lookup metafield (attached to productJson as __comboLookup).
   * Key = OfferValue + '__' + colors joined by '-' (any permutation), then [size].
   * Returns null when the metafield is absent or the combo isn't found, so callers
   * fall back to the existing first-250 variant logic.
   */
  function findComboVariantId(productJson, offerValue, colorsArr, size) {
    const lookup = productJson && productJson.__comboLookup;
    if (!lookup || typeof lookup !== 'object') return null;
    if (!offerValue || !size || !Array.isArray(colorsArr) || colorsArr.length < 2) return null;
    const colors = colorsArr.map((c) => String(c || '').trim()).filter(Boolean);
    if (colors.length < 2) return null;
    const perms = getPermutations(colors);
    for (let pi = 0; pi < perms.length; pi++) {
      const key = offerValue + '__' + perms[pi].join('-');
      const sizes = lookup[key];
      if (sizes && sizes[size] != null) return sizes[size];
    }
    return null;
  }

  /** Selected color for each of the first `count` bundle rows (swatch -> hidden input -> default). */
  function getSelectedBundleColors(root, count) {
    const rows = qsa(root, '.bundle-item');
    const colors = [];
    for (let i = 0; i < count; i++) {
      const row = rows[i];
      const swatch = row && row.querySelector('.bundle-fixed-swatch[aria-pressed="true"]');
      let color = swatch ? (swatch.dataset.color || swatch.dataset.comboId || '').trim() : '';
      if (!color) {
        color = (
          root.querySelector('input[name="properties[_bundle_color_' + (i + 1) + ']"]')?.value ||
          getDefaultColor(root)
        ).trim();
      }
      colors.push(color || getDefaultColor(root));
    }
    return colors;
  }

  function getDefaultSizeForPopup21(root, productJson) {
    let size = (qs(root, '.bundle-items__size')?.textContent || '').trim();
    if (size) return size;
    const form = findProductForm(root);
    if (form) size = getSelectedSizeFromForm(productJson, form);
    if (size) return size;
    const offer21 = getOffer2Plus1Value(productJson);
    if (!offer21) return '';
    const offerIndex = findOfferOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const first = (productJson.variants || []).find((v) => {
      const ov = String([v.option1, v.option2, v.option3][offerIndex] || '').trim();
      return ov === offer21;
    });
    return first ? String([first.option1, first.option2, first.option3][sizeIndex] || '').trim() : '';
  }

  function setPopup21Combo(root, combo) {
    const formId = root.querySelector('input[name="properties[_bundle]"]')?.getAttribute('form') || null;
    ensureHidden(root, formId, 'properties[_bundle_color_1]', combo.c1);
    ensureHidden(root, formId, 'properties[_bundle_color_2]', combo.c2);
    ensureHidden(root, formId, 'properties[_bundle_color_3]', combo.c3);
    const productJson = getProductJson(root);
    const form = findProductForm(root);
    if (productJson && form) {
      const size = getDefaultSizeForPopup21(root, productJson);
      const offer21 = getOffer2Plus1Value(productJson);
      const v1 = findVariant21(productJson, combo.c1, size, offer21);
      const v2 = findVariant21(productJson, combo.c2, size, offer21);
      const v3 = findVariant21(productJson, combo.c3, size, offer21);
      if (v1 && v1.id) ensureHidden(root, formId, 'properties[_bundle_variant_id_1]', String(v1.id));
      if (v2 && v2.id) ensureHidden(root, formId, 'properties[_bundle_variant_id_2]', String(v2.id));
      if (v3 && v3.id) ensureHidden(root, formId, 'properties[_bundle_variant_id_3]', String(v3.id));
      const variantForImage = findVariantByFarbeLabelSizeOffer(productJson, combo.label, size, offer21) || v1;
      if (variantForImage) updateBundleRowImage(root, productJson, variantForImage);
    }
    const header = qs(root, '.bundle-items__colors');
    if (header) header.textContent = combo.label;
    const colorLabel = root.querySelector('.bundle-item__color');
    if (colorLabel) colorLabel.textContent = combo.label;
  }

  function renderPopup21ComboSwatches(root, container, selectedComboId, combos) {
    if (!combos || !combos.length) return;
    container.innerHTML = '';
    const wrap = document.createElement('div');
    wrap.className = 'bundle-fixed-swatches';
    combos.forEach((combo) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-fixed-swatch';
      if (combo.available === false) btn.classList.add('bundle-fixed-swatch--disabled');
      btn.dataset.comboId = combo.id;
      btn.setAttribute('aria-pressed', selectedComboId === combo.id ? 'true' : 'false');
      btn.setAttribute('aria-disabled', combo.available !== false ? 'false' : 'true');
      const same = combo.c1 === combo.c2 && combo.c2 === combo.c3;
      const twoSame = combo.c1 === combo.c2 || combo.c2 === combo.c3;
      const isMulti = /multicolor|multi-color|multi\s*color/i.test(combo.c1 || combo.c2 || combo.c3);
      const h1 = getColorHex(combo.c1) || '#ccc';
      const h2 = getColorHex(combo.c2) || '#ccc';
      const h3 = getColorHex(combo.c3) || '#ccc';
      let dotStyle;
      if (combo.available === false) dotStyle = 'background:#bdbdbd';
      else if (same && isMulti)
        dotStyle =
          'background:linear-gradient(to right, #000 0%, #000 33%, #e7cfb3 33%, #e7cfb3 70%, #fff 70%, #fff 100%)';
      else if (same) dotStyle = h1 === '#fff' ? 'background:#fff' : 'background:' + h1;
      else if (twoSame && combo.c1 === combo.c2)
        dotStyle = 'background:linear-gradient(to right, ' + h1 + ' 66%, ' + h3 + ' 34%)';
      else if (twoSame && combo.c2 === combo.c3)
        dotStyle = 'background:linear-gradient(to right, ' + h1 + ' 34%, ' + h2 + ' 66%)';
      else
        dotStyle = 'background:linear-gradient(to right, ' + h1 + ' 33.33%, ' + h2 + ' 66.66%, ' + h3 + ' 100%)';
      btn.innerHTML =
        '<span class="bundle-fixed-swatch__dot" style="' +
        dotStyle +
        '" aria-hidden="true"></span><span class="bundle-fixed-swatch__label">' +
        combo.label +
        '</span>';
      if (combo.available !== false) {
        btn.addEventListener('click', () => {
          setPopup21Combo(root, combo);
          wrap
            .querySelectorAll('.bundle-fixed-swatch')
            .forEach((b) => b.setAttribute('aria-pressed', b.dataset.comboId === combo.id ? 'true' : 'false'));
        });
      } else {
        btn.disabled = true;
      }
      wrap.appendChild(btn);
    });
    container.appendChild(wrap);
  }

  function setPopup11Combo(root, combo) {
    const formId = root.querySelector('input[name="properties[_bundle]"]')?.getAttribute('form') || null;
    ensureHidden(root, formId, 'properties[_bundle_color_1]', combo.c1);
    ensureHidden(root, formId, 'properties[_bundle_color_2]', combo.c2);

    const productJson = getProductJson(root);
    const form = findProductForm(root);
    if (productJson && form) {
      const size = getDefaultSizeForPopup11(root, productJson);
      const offer1 = getOffer1Plus1Value(productJson);

      const vv = findVariantByFarbeLabelSizeOffer(productJson, combo.label, size, offer1);

      if (vv && vv.id) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = String(vv.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          setVariantInUrl(vv.id);
        }

        ensureHidden(root, formId, 'properties[_bundle_variant_id_1]', String(vv.id));
        updateBundleRowImage(root, productJson, vv);
      }
    }

    qs(root, '.bundle-items__colors') && (qs(root, '.bundle-items__colors').textContent = combo.label);
    root.querySelector('.bundle-item__color') &&
      (root.querySelector('.bundle-item__color').textContent = combo.label);
  }

  function renderPopup11ComboSwatches(root, container, selectedComboId, combos) {
    if (!combos || !combos.length) return;
    container.innerHTML = '';
    const wrap = document.createElement('div');
    wrap.className = 'bundle-fixed-swatches';
    combos.forEach((combo) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-fixed-swatch';
      if (combo.available === false) btn.classList.add('bundle-fixed-swatch--disabled');
      btn.dataset.comboId = combo.id;
      btn.setAttribute('aria-pressed', selectedComboId === combo.id ? 'true' : 'false');
      btn.setAttribute('aria-disabled', combo.available !== false ? 'false' : 'true');
      const isSame = combo.c1 === combo.c2;
      const isMulti = /multicolor|multi-color|multi\s*color/i.test(combo.c1 || combo.c2);
      let dotStyle;
      if (combo.available === false) dotStyle = 'background:#bdbdbd';
      else if (isSame && isMulti)
        dotStyle =
          'background:linear-gradient(to right, #000 0%, #000 33%, #e7cfb3 33%, #e7cfb3 70%, #fff 70%, #fff 100%)';
      else if (isSame) {
        const h = getColorHex(combo.c1) || '#ccc';
        dotStyle = h === '#fff' ? 'background:#fff' : 'background:' + h;
      } else {
        const h1 = getColorHex(combo.c1) || '#ccc';
        const h2 = getColorHex(combo.c2) || '#ccc';
        dotStyle = 'background:linear-gradient(to right, ' + h1 + ' 53%, ' + h2 + ' 53%)';
      }
      btn.innerHTML =
        '<span class="bundle-fixed-swatch__dot" style="' +
        dotStyle +
        '" aria-hidden="true"></span><span class="bundle-fixed-swatch__label">' +
        combo.label +
        '</span>';
      if (combo.available !== false) {
        btn.addEventListener('click', () => {
          setPopup11Combo(root, combo);
          wrap
            .querySelectorAll('.bundle-fixed-swatch')
            .forEach((b) => b.setAttribute('aria-pressed', b.dataset.comboId === combo.id ? 'true' : 'false'));
        });
      } else {
        btn.disabled = true;
      }
      wrap.appendChild(btn);
    });
    container.appendChild(wrap);
  }

  function renderFixedSwatches(root, container, rowIndex, activeColor, productJson, bundle) {
    container.innerHTML = '';
    const wrap = document.createElement('div');
    wrap.className = 'bundle-fixed-swatches';
    const product = productJson || getProductJson(root);
    const colors =
      product && bundle
        ? getColorsFromProduct(product, bundle)
        : COLORS.map((c) => ({ label: c.label, available: true }));

    colors.forEach((c) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-fixed-swatch';
      if (!c.available) btn.classList.add('bundle-fixed-swatch--disabled');
      btn.dataset.color = c.label;
      btn.setAttribute('aria-pressed', activeColor === c.label ? 'true' : 'false');
      btn.setAttribute('aria-disabled', c.available ? 'false' : 'true');
      const { c1, c2 } = parseComboLabel(c.label);
      const isCombo = c1 !== c2;
      const isMulti = /multicolor|multicolour|multi-color|multi colour|multi\s*color/i.test(
        c.label || c1 || c2 || ''
      );
      let dotStyle;
      if (isMulti) {
        dotStyle =
          'background:linear-gradient(to right, #000 0%, #000 33%, #e7cfb3 33%, #e7cfb3 70%, #fff 70%, #fff 100%)';
      } else if (isCombo) {
        const hex1 = getColorHex(c1) || '#ccc';
        const hex2 = getColorHex(c2) || '#ccc';
        dotStyle = 'background:linear-gradient(to right, ' + hex1 + ' 53%, ' + hex2 + ' 53%)';
      } else {
        // Prefer the hex from the color_swatches metaobject; fall back to name mapping.
        // Validate it's a real #hex so a bad/object value never becomes "[object Object]".
        const rawHex = typeof c.hex === 'string' ? c.hex.trim() : '';
        const validHex = /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(rawHex) ? rawHex : '';
        const hex = validHex || getColorHex(c.label) || '#ccc';
        const hl = hex.toLowerCase();
        dotStyle = hl === '#fff' || hl === '#ffffff' ? 'background:#fff' : 'background:' + hex;
      }
      btn.innerHTML = `
        <span class="bundle-fixed-swatch__dot" style="${dotStyle}" aria-hidden="true"></span>
        <span class="bundle-fixed-swatch__label">${c.label}</span>
      `;
      if (c.available) {
        btn.addEventListener('click', () => setBundleColor(root, rowIndex, c.label));
      } else {
        btn.disabled = true;
      }
      wrap.appendChild(btn);
    });

    container.appendChild(wrap);
  }

  function renderItems(root, bundle) {
    const list = qs(root, '.bundle-items__list');
    if (!list) return;

    const count = bundle === 'single' ? 1 : bundle === 'one_plus_one' ? 2 : 3;
    const thumb = root.dataset.thumb || '';
    const imgHtml = thumb ? `<img src="${thumb}" alt="" loading="lazy">` : '';
    const bundleInput = qs(root, 'input[name="properties[_bundle]"]');
    const formId = bundleInput?.getAttribute('form') || null;

    function ensureHiddenVariantIdProperties(root, formId, count) {
      for (let i = 1; i <= count; i++) {
        const name = `properties[_bundle_variant_id_${i}]`;
        if (!root.querySelector(`input[name="${CSS.escape(name)}"]`)) {
          ensureHidden(root, formId, name, '');
        }
      }
    }

    const isPopup11 = root.dataset.popup === 'true' && bundle === 'one_plus_one';
    if (isPopup11) {
      list.innerHTML = '';
      ensureHiddenColorProperties(root, formId, 2);
      ensureHiddenVariantIdProperties(root, formId, 2);
      const productJson = getProductJson(root);
      const combos = getPopup11CombosFromProduct(productJson);
      root._popup11Combos = combos;
      const thumb11 = root.dataset.popup11Thumb || root.dataset.thumb || '';
      const imgHtml11 = thumb11 ? `<img src="${thumb11}" alt="" loading="lazy">` : '';
      const colorLabel = root.dataset.popupColorLabel || 'Color';
      const row = document.createElement('div');
      row.className = 'bundle-item bundle-item--popup-11';
      row.innerHTML = `
        <div class="bundle-item__img">${imgHtml11}</div>
        <div class="bundle-item__meta">
          <div class="bundle-item__row-title">
            ${colorLabel}: <strong><span class="bundle-item__color">—</span></strong>
          </div>
          <div class="bundle-item__swatches bundle-item__popup-11-combos-wrap"></div>
        </div>
      `;
      list.appendChild(row);
      const comboContainer = row.querySelector('.bundle-item__popup-11-combos-wrap');
      const selected = combos.find((c) => c.available !== false) || combos[0];
      if (combos.length && comboContainer) {
        renderPopup11ComboSwatches(root, comboContainer, selected ? selected.id : '', combos);
        if (selected) setPopup11Combo(root, selected);
      }
      const header = qs(root, '.bundle-items__colors');
      if (header) header.textContent = selected ? selected.label : '—';
      const defaultSize = getDefaultSizeForPopup11(root, productJson);
      if (defaultSize) {
        const sizeEl = qs(root, '.bundle-items__size');
        if (sizeEl) sizeEl.textContent = defaultSize;
      }
      return;
    }

    const isPopup21 = root.dataset.popup === 'true' && bundle === 'two_plus_one';
    if (isPopup21) {
      list.innerHTML = '';
      ensureHiddenColorProperties(root, formId, 3);
      ensureHiddenVariantIdProperties(root, formId, 3);
      const productJson = getProductJson(root);
      const combos = getPopup21CombosFromProduct(productJson);
      root._popup21Combos = combos;
      const thumb21 = root.dataset.popup21Thumb || root.dataset.thumb || '';
      const imgHtml21 = thumb21 ? `<img src="${thumb21}" alt="" loading="lazy">` : '';
      const colorLabel21 = root.dataset.popupColorLabel || 'Farbe';
      const row = document.createElement('div');
      row.className = 'bundle-item bundle-item--popup-21';
      row.innerHTML = `
        <div class="bundle-item__img">${imgHtml21}</div>
        <div class="bundle-item__meta">
          <div class="bundle-item__row-title">
            ${colorLabel21}: <strong><span class="bundle-item__color">—</span></strong>
          </div>
          <div class="bundle-item__swatches bundle-item__popup-21-combos-wrap"></div>
        </div>
      `;
      list.appendChild(row);
      const comboContainer = row.querySelector('.bundle-item__popup-21-combos-wrap');
      const selected = combos.find((c) => c.available !== false) || combos[0];
      if (combos.length && comboContainer) {
        renderPopup21ComboSwatches(root, comboContainer, selected ? selected.id : '', combos);
        if (selected) setPopup21Combo(root, selected);
      }
      const header = qs(root, '.bundle-items__colors');
      if (header) header.textContent = selected ? selected.label : '—';
      const defaultSize = getDefaultSizeForPopup21(root, productJson);
      if (defaultSize) {
        const sizeEl = qs(root, '.bundle-items__size');
        if (sizeEl) sizeEl.textContent = defaultSize;
      }
      return;
    }

    list.innerHTML = '';
    const colorLabel = root.dataset.colorLabel || root.dataset.popupColorLabel || 'Color';
    for (let i = 0; i < count; i++) {
      const row = document.createElement('div');
      row.className = 'bundle-item';
      row.innerHTML = `
        <div class="bundle-item__img">${imgHtml}</div>
        <div class="bundle-item__meta">
          <div class="bundle-item__row-title">
            ${colorLabel}: <strong><span class="bundle-item__color">—</span></strong>
          </div>
          <div class="bundle-item__swatches"></div>
        </div>
      `;
      list.appendChild(row);
    }

    ensureHiddenColorProperties(root, formId, count);
    ensureHiddenVariantIdProperties(root, formId, count);

    const defColor = getDefaultColor(root, bundle);
    qsa(root, '.bundle-item').forEach((row, idx) => {
      const current =
        root.querySelector('input[name="' + CSS.escape('properties[_bundle_color_' + (idx + 1) + ']') + '"]')
          ?.value || defColor;

      const label = row.querySelector('.bundle-item__color');
      if (label) label.textContent = current;

      const sw = row.querySelector('.bundle-item__swatches');
      if (
        sw &&
        !row.classList.contains('bundle-item--popup-11') &&
        !row.classList.contains('bundle-item--popup-21')
      )
        renderFixedSwatches(root, sw, idx, current, getProductJson(root), bundle);
    });

    qsa(root, '.bundle-item').forEach((_, idx) => {
      const current =
        root.querySelector('input[name="' + CSS.escape('properties[_bundle_color_' + (idx + 1) + ']') + '"]')
          ?.value || defColor;
      setBundleColor(root, idx, current);
    });

    const header = qs(root, '.bundle-items__colors');
    if (header) {
      const values = [];
      for (let i = 0; i < count; i++) {
        values.push(
          root.querySelector('input[name="' + CSS.escape('properties[_bundle_color_' + (i + 1) + ']') + '"]')
            ?.value || '—'
        );
      }
      header.textContent = values.join(', ');
    }
  }

  // ---------- Product JSON + variant resolution ----------
  function getProductJson(root) {
    let s = root && root.querySelector('script.bundle-product-json');
    if (!s)
      s =
        document.querySelector('.bundle-picker script.bundle-product-json') ||
        document.querySelector('script.bundle-product-json');
    if (!s) return null;
    try {
      const pj = JSON.parse(s.textContent);
      // Attach the ordered offer values emitted by Liquid (.bundle-offer-order):
      // [single, one_plus_one, two_plus_one]. Lets offer detection work by
      // POSITION regardless of the merchant's offer value names.
      try {
        const picker =
          (root && root.closest && root.closest('.bundle-picker')) ||
          (s.closest && s.closest('.bundle-picker'));
        const orderEl =
          (picker && picker.querySelector('script.bundle-offer-order')) ||
          document.querySelector('.bundle-picker script.bundle-offer-order');
        if (orderEl && orderEl.textContent && orderEl.textContent.trim()) {
          const arr = JSON.parse(orderEl.textContent);
          if (Array.isArray(arr) && arr.length) pj.__offerOrder = arr.map((x) => String(x).trim());
        }
      } catch (e) {}
      // Attach the 250-variant-bypass metafields (emitted by bundle-selector.liquid):
      //   __comboLookup  = { "OfferValue__Color-Color": { "Size": variantId }, ..., "_offer_prices": {...} }
      //   __comboImages  = { "Color": "cdn_url" }
      // Both stay null when the metafields don't exist yet, so combo lookup is a no-op
      // and the existing first-250 logic keeps working unchanged.
      try {
        const pickerEl =
          (root && root.closest && root.closest('.bundle-picker')) ||
          (s.closest && s.closest('.bundle-picker'));
        const lookupEl =
          (pickerEl && pickerEl.querySelector('script.bundle-combo-lookup')) ||
          document.querySelector('.bundle-picker script.bundle-combo-lookup');
        if (lookupEl && lookupEl.textContent && lookupEl.textContent.trim()) {
          const lk = JSON.parse(lookupEl.textContent);
          if (lk && typeof lk === 'object') pj.__comboLookup = lk;
        }
        const imagesEl =
          (pickerEl && pickerEl.querySelector('script.bundle-combo-images')) ||
          document.querySelector('.bundle-picker script.bundle-combo-images');
        if (imagesEl && imagesEl.textContent && imagesEl.textContent.trim()) {
          const im = JSON.parse(imagesEl.textContent);
          if (im && typeof im === 'object') pj.__comboImages = im;
        }
        // Color swatches from the custom.color_swatches metaobject list ({label, hex}).
        const swEl =
          (pickerEl && pickerEl.querySelector('script.bundle-color-swatches')) ||
          document.querySelector('.bundle-picker script.bundle-color-swatches');
        if (swEl && swEl.textContent && swEl.textContent.trim()) {
          const sw = JSON.parse(swEl.textContent);
          if (Array.isArray(sw) && sw.length) pj.__colorSwatches = sw;
        }
        // Per-combo-variant stock ({ variantId: {q,p,m} }) for stock-notice + preorder.
        const stEl =
          (pickerEl && pickerEl.querySelector('script.bundle-combo-stock')) ||
          document.querySelector('.bundle-picker script.bundle-combo-stock');
        if (stEl && stEl.textContent && stEl.textContent.trim()) {
          const st = JSON.parse(stEl.textContent);
          if (st && typeof st === 'object') pj.__comboStock = st;
        }
      } catch (e) {}
      return pj;
    } catch (e) {
      return null;
    }
  }

  function getVariantPopupImageMap(root) {
    const picker = root && root.closest ? root.closest('.bundle-picker') : null;
    const parent = picker && picker.parentElement;
    const fromParent = parent && parent.querySelector('script.bundle-variant-popup-images');
    const fromPicker = picker && picker.querySelector('script.bundle-variant-popup-images');
    const fromDoc = document.querySelector('script.bundle-variant-popup-images');
    const s = fromParent || fromPicker || fromDoc;
    if (!s || !s.textContent || !s.textContent.trim()) return null;
    try {
      const raw = s.textContent.trim();
      const parsed = JSON.parse(raw);
      const map = parsed && typeof parsed === 'object' ? parsed : null;
      return map;
    } catch (e) {
      const raw = s.textContent.trim();
      const map = {};
      const re = /"(\d{10,})":\s*"((?:[^"\\]|\\.)*)"/g;
      let m;
      while ((m = re.exec(raw)) !== null) map[m[1]] = m[2].replace(/\\\//g, '/');
      if (Object.keys(map).length > 0) return map;
      const reBroken = /\\"(\d+)\\"\s*:\s*\\\/\\\/([^"\\]+)/g;
      while ((m = reBroken.exec(raw)) !== null) {
        map[m[1]] = 'https://' + m[2].replace(/\\\//g, '/');
      }
      if (Object.keys(map).length > 0) return map;
      return null;
    }
  }

  function getPopupImageUrl(root, variant) {
    if (!variant || !variant.id) return null;
    const map = getVariantPopupImageMap(root);
    if (!map) return null;
    const idStr = String(variant.id);
    const idNum = Number(variant.id);
    let url = map[idStr] || map[idNum] || null;
    if (
      typeof url === 'string' &&
      url.length >= 2 &&
      url.charAt(0) === '"' &&
      url.charAt(url.length - 1) === '"'
    ) {
      url = url.slice(1, -1).replace(/\\"/g, '"');
    }
    return typeof url === 'string' && url ? url : null;
  }

  function getCurrentVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }

  function findColorOptionIndex(productJson) {
    const names = (productJson.options || []).map((o) => (typeof o === 'string' ? o : o?.name)).filter(Boolean);
    for (let i = 0; i < names.length; i++) {
      const n = String(names[i]).toLowerCase();
      if (n.includes('farbe') || n.includes('color')) return i;
    }
    return 0;
  }

  function get2plus1BundlePriceFromDOM(root) {
    const fromData =
      root.dataset.bundle2plus1Price != null && root.dataset.bundle2plus1Price !== ''
        ? parseFloat(String(root.dataset.bundle2plus1Price).replace(',', '.'))
        : NaN;
    if (!Number.isNaN(fromData) && fromData > 0) return fromData;
    const card21 =
      root.querySelector('.new-form-option[data-offers-pointer="2"]') ||
      document.querySelector('.new-form-option[data-offers-pointer="2"]');
    if (!card21) return 0;
    const priceWrap = card21.querySelector('.price-new-form');
    const saleEl = priceWrap && priceWrap.querySelector('.first-price-WB');
    const raw = saleEl
      ? (saleEl.textContent || '')
          .replace(/[^\d,.]/g, '')
          .replace(',', '.')
          .trim()
      : '';
    const num = parseFloat(raw);
    return Number.isNaN(num) || num <= 0 ? 0 : num;
  }

  function parseMoneyTextToCents(text) {
    if (!text) return null;
    let s = String(text)
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');
    if (!s) return null;
    const hasComma = s.includes(',');
    const hasDot = s.includes('.');
    if (hasComma && hasDot) s = s.replace(/\./g, '').replace(',', '.');
    else if (hasComma) s = s.replace(',', '.');
    const n = Number(s);
    return Number.isFinite(n) ? Math.round(n * 100) : null;
  }

  function setPriceNodeWithSr(el, formatted) {
    if (!el || !formatted) return;
    const sr = el.querySelector('.sr-only');
    el.innerHTML = (sr ? sr.outerHTML : '') + formatted;
    el.style.display = '';
  }

  function syncMainPriceFromOffer(root, bundle) {
    if (!root) return;
    const sectionRoot = root.closest('.shopify-section') || document;
    const swatches = qsa(root, '.new-form-option');
    let card = null;
    if (bundle === 'single') card = swatches[0] || null;
    else if (bundle === 'one_plus_one') card = swatches[1] || null;
    else if (bundle === 'two_plus_one') card = swatches[2] || null;
    if (!card) {
      if (bundle === 'one_plus_one')
        card =
          qs(root, '.new-form-option[data-offers-pointer="1"]') ||
          qs(document, '.new-form-option[data-offers-pointer="1"]');
      if (bundle === 'two_plus_one')
        card =
          qs(root, '.new-form-option[data-offers-pointer="2"]') ||
          qs(document, '.new-form-option[data-offers-pointer="2"]');
    }
    if (!card) return;

    const priceWrap = qs(card, '.price-new-form') || card;
    const saleText = (qs(priceWrap, '.first-price-WB')?.textContent || '').trim();
    const compareText = (qs(priceWrap, '.second-price-WB')?.textContent || '').trim();
    const saleCents = parseMoneyTextToCents(saleText);
    const compareCents = parseMoneyTextToCents(compareText);
    if (!saleCents || saleCents <= 0) return;

    const priceBlock =
      qs(sectionRoot, '.product-info__block-item.new-pdp[data-block-id="price"]') ||
      qs(sectionRoot, '.product-info__block-item[data-block-type="price"]') ||
      qs(document, '.product-info__block-item.new-pdp[data-block-id="price"]') ||
      qs(document, '.product-info__block-item[data-block-type="price"]');
    if (!priceBlock) return;

    const priceList = qs(priceBlock, 'price-list');
    if (!priceList) return;

    const sale = qs(priceList, 'sale-price');
    const regular = qs(priceList, 'regular-price');
    const compare = qs(priceList, 'compare-at-price');
    const fallback = qs(priceList, '[data-price]') || qs(priceList, '.price') || qs(priceList, 'span.price');

    const saleFormatted =
      window.Shopify && typeof window.Shopify.formatMoney === 'function'
        ? window.Shopify.formatMoney(saleCents, window.themeVariables?.settings?.moneyFormat || '${{amount}}')
        : (saleCents / 100).toFixed(2);

    setPriceNodeWithSr(sale, saleFormatted);
    setPriceNodeWithSr(regular, saleFormatted);
    if (!sale && !regular) setPriceNodeWithSr(fallback, saleFormatted);

    if (compare) {
      if (compareCents && compareCents > saleCents) {
        const compareFormatted =
          window.Shopify && typeof window.Shopify.formatMoney === 'function'
            ? window.Shopify.formatMoney(
                compareCents,
                window.themeVariables?.settings?.moneyFormat || '${{amount}}'
              )
            : (compareCents / 100).toFixed(2);
        setPriceNodeWithSr(compare, compareFormatted);
        compare.style.display = '';
      } else {
        compare.style.display = 'none';
      }
    }
  }

  function syncMainPriceFromFormVariant(root, form, productJson, reason, overrideBundleKey) {
    if (!root || !form || !productJson) return;

    let saleCents;
    let compareCents;

    // Combo offers (1+1 / 2+1): the real combo variant is beyond the 250-variant
    // window, so take the whole-bundle total from the lookup metafield instead of
    // the currently-selected form variant (which would show the single price).
    // overrideBundleKey lets the initial single-price lock force 'single' even while
    // the selected offer is 1+1 (the marketing display: show single, add 1+1 to cart).
    const bundleKey = overrideBundleKey || getBundleKeyFromRoot(root);
    if (bundleKey === 'one_plus_one' || bundleKey === 'two_plus_one') {
      const offerValue =
        bundleKey === 'one_plus_one' ? getOffer1Plus1Value(productJson) : getOffer2Plus1Value(productJson);
      const totals = getComboOfferTotals(productJson, offerValue);
      if (totals && totals.priceCents > 0) {
        saleCents = totals.priceCents;
        compareCents = totals.compareCents;
        // Fallback for the strikethrough: if the metafield has no _offer_compare yet,
        // use the compare shown on the offer card (data-bundle2/3-compare).
        if (!compareCents) {
          const attr =
            bundleKey === 'one_plus_one' ? root.dataset.bundle2Compare : root.dataset.bundle3Compare;
          const c = parseMoneyTextToCents(attr || '');
          if (c && c > saleCents) compareCents = c;
        }
      }
    }

    if (saleCents == null) {
      const idInput = form.querySelector('input[name="id"]');
      const variantId = idInput ? String(idInput.value || '').trim() : '';
      if (!variantId) return;
      const variant = (productJson.variants || []).find((v) => String(v.id) === variantId);
      if (!variant) return;
      saleCents = Number(variant.price || 0);
      compareCents = Number(variant.compare_at_price || 0);
    }
    if (!Number.isFinite(saleCents) || saleCents <= 0) return;

    const sectionRoot = root.closest('.shopify-section') || document;
    const priceBlock =
      qs(sectionRoot, '.product-info__block-item.new-pdp[data-block-id="price"]') ||
      qs(sectionRoot, '.product-info__block-item[data-block-type="price"]') ||
      qs(document, '.product-info__block-item.new-pdp[data-block-id="price"]') ||
      qs(document, '.product-info__block-item[data-block-type="price"]');
    if (!priceBlock) return;
    const priceList = qs(priceBlock, 'price-list');
    if (!priceList) return;

    const sale = qs(priceList, 'sale-price');
    const regular = qs(priceList, 'regular-price');
    const compare = qs(priceList, 'compare-at-price');
    const fallback = qs(priceList, '[data-price]') || qs(priceList, '.price') || qs(priceList, 'span.price');

    const saleFormatted =
      window.Shopify && typeof window.Shopify.formatMoney === 'function'
        ? window.Shopify.formatMoney(saleCents, window.themeVariables?.settings?.moneyFormat || '${{amount}}')
        : (saleCents / 100).toFixed(2);

    setPriceNodeWithSr(sale, saleFormatted);
    setPriceNodeWithSr(regular, saleFormatted);
    if (!sale && !regular) setPriceNodeWithSr(fallback, saleFormatted);

    if (compare) {
      if (compareCents > saleCents) {
        const compareFormatted =
          window.Shopify && typeof window.Shopify.formatMoney === 'function'
            ? window.Shopify.formatMoney(
                compareCents,
                window.themeVariables?.settings?.moneyFormat || '${{amount}}'
              )
            : (compareCents / 100).toFixed(2);
        setPriceNodeWithSr(compare, compareFormatted);
        compare.style.display = '';
      } else {
        compare.style.display = 'none';
      }
    }
  }

  function getOptionNames(productJson) {
    const opts = productJson.options || [];
    return opts.map((o) => (typeof o === 'string' ? o : o?.name) || 'Option ' + (opts.indexOf(o) + 1));
  }

  function findVariantByOptions(productJson, wantedOptions) {
    const variants = productJson.variants || [];
    return (
      variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3].filter((x) => x != null);
        if (opts.length !== wantedOptions.length) return false;
        for (let i = 0; i < opts.length; i++) {
          if (String(opts[i]) !== String(wantedOptions[i])) return false;
        }
        return true;
      }) || null
    );
  }

  function findVariantByColorAndSize(productJson, colorName, size) {
    const variants = productJson.variants || [];
    const colorIndex = findColorOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const colorLower = String(colorName).trim().toLowerCase();
    return (
      variants.find((v) => {
        const c = [v.option1, v.option2, v.option3][colorIndex];
        const s = [v.option1, v.option2, v.option3][sizeIndex];
        const matchColor = c != null && String(c).trim().toLowerCase() === colorLower;
        const matchSize = size === '' || (s != null && String(s).trim() === String(size).trim());
        return matchColor && matchSize;
      }) || null
    );
  }

  function getImageUrlForColor(productJson, colorName) {
    const colorLower = String(colorName).trim().toLowerCase();
    const colorIndex = findColorOptionIndex(productJson);
    let variant = (productJson.variants || []).find((v) => {
      const c = [v.option1, v.option2, v.option3][colorIndex];
      return c != null && String(c).trim().toLowerCase() === colorLower;
    });
    if (variant) {
      const url = getVariantImageUrl(productJson, variant);
      if (url) return url;
    }
    const images = productJson.images || [];
    const img = images.find((im) => {
      const alt = (im.alt || im.title || '').toLowerCase();
      return alt && colorLower && alt.includes(colorLower);
    });
    if (img) return img.src || img;
    if (images.length) return images[0].src || images[0];
    return null;
  }

  function updateBundleRowImage(root, productJson, variant) {
    if (!root || !productJson) return;
    const list = qs(root, '.bundle-items__list');
    const row = list ? list.querySelector('.bundle-item') : null;
    if (!row) return;
    let imgUrl = null;
    if (root.dataset.popup === 'true') {
      if (variant) imgUrl = getPopupImageUrl(root, variant);
    } else {
      if (variant) imgUrl = getPopupImageUrl(root, variant);
      if (!imgUrl && variant) imgUrl = getVariantImageUrl(productJson, variant);
      if (!imgUrl && variant) {
        const colorIndex = findColorOptionIndex(productJson);
        const colorName = [variant.option1, variant.option2, variant.option3][colorIndex];
        if (colorName) imgUrl = getImageUrlForColor(productJson, colorName);
      }
    }
    const thumbEl = row.querySelector('.bundle-item__img');
    if (!thumbEl) return;
    if (imgUrl) {
      const url = typeof imgUrl === 'string' ? imgUrl : imgUrl.src || imgUrl.url;
      if (url) {
        const img = thumbEl.querySelector('img');
        if (img) img.src = url;
        else thumbEl.innerHTML = `<img src="${url}" alt="" loading="lazy">`;
      }
    }
  }

  function findSizeOptionIndex(productJson) {
    const names = (productJson.options || []).map((o) => (typeof o === 'string' ? o : o?.name)).filter(Boolean);
    for (let i = 0; i < names.length; i++) {
      const n = String(names[i]).toLowerCase();
      if (n.includes('größe') || n.includes('grösse') || n.includes('size')) return i;
    }
    return productJson.options && productJson.options.length >= 2 ? 1 : 0;
  }

  async function addItems(items) {
    const url = `${routesRoot()}cart/add.js`;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || 'Add to cart failed');
    }

    return res.json();
  }

  function getBundleCount(bundle) {
    return bundle === 'single' ? 1 : bundle === 'one_plus_one' ? 2 : 3;
  }

  function getRowSelectedColor(root, rowIndex) {
    const row = qsa(root, '.bundle-item')[rowIndex];
    const swatch = row && row.querySelector('.bundle-fixed-swatch[aria-pressed="true"]');
    if (swatch && (swatch.dataset.color || swatch.dataset.comboId))
      return (swatch.dataset.color || swatch.dataset.comboId).trim();

    const name = `properties[_bundle_color_${rowIndex + 1}]`;
    return (root.querySelector(`input[name="${CSS.escape(name)}"]`)?.value || getDefaultColor(root)).trim();
  }

  function getSelectedSize(root, productJson, form) {
    let size = (qs(root, '.bundle-items__size')?.textContent || '').trim();
    if (size) return size;

    const vid = getCurrentVariantIdFromForm(form);
    const v = vid ? (productJson.variants || []).find((x) => Number(x.id) === Number(vid)) : null;
    if (!v) return '';

    const sizeIdx = findSizeOptionIndex(productJson);
    return ([v.option1, v.option2, v.option3][sizeIdx] || '').trim();
  }

  function resolveVariantIdByColorSize(productJson, color, size) {
    const v = findVariantByColorAndSize(productJson, color, size);
    return v ? Number(v.id) : null;
  }

  async function openCartDrawer() {
    const cartToggle =
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('[aria-controls*="cart"]') ||
      document.querySelector('a[href="/cart"].header__icon') ||
      document.querySelector('a[href*="/cart"].header__icon') ||
      document.querySelector('[href="/cart"]');

    if (cartToggle) {
      cartToggle.click();
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  function getAdditionalPopupVariantIds() {
    var modal = document.querySelector('.product-popup-modal--additional');
    var str = (modal && modal.getAttribute('data-open-popup-variant-ids')) || '';
    if (!str) {
      var wrapper = document.querySelector('[data-additional-popup-variant-ids]');
      str = (wrapper && wrapper.getAttribute('data-additional-popup-variant-ids')) || '';
    }
    if (!str) return [];
    return str
      .split(',')
      .map(function (s) {
        return String(s).trim();
      })
      .filter(Boolean);
  }

  async function openAdditionalPopupOrCart(items, root) {
    const additionalIds = getAdditionalPopupVariantIds();
    const addedIds = (items || []).map(function (item) {
      return String(item.id);
    });
    const shouldOpenAdditionalPopup = addedIds.some(function (id) {
      return additionalIds.indexOf(id) !== -1;
    });
    if (shouldOpenAdditionalPopup && additionalIds.length > 0) {
      document.dispatchEvent(
        new CustomEvent('variant:add', {
          detail: {
            items: items.map(function (i) {
              return { variant_id: i.id };
            }),
            blockCartDrawerOpening: true,
          },
          bubbles: true,
        })
      );
      var additionalModal = document.querySelector('.product-popup-modal--additional');
      if (additionalModal) {
        additionalModal.classList.add('is-open');
        additionalModal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
        document.body.classList.add('no-scroll');
      }
      return;
    }
    await openCartDrawerAfterClosePopupIfNeeded(root);
  }

  async function openCartDrawerAfterClosePopupIfNeeded(root) {
    if (root && root.dataset.popup === 'true') {
      var modal = root.closest('.product-popup-modal') || document.querySelector('.product-popup-modal.is-open');
      if (
        modal &&
        !modal.classList.contains('product-popup-modal--additional') &&
        typeof modal.closeProductPopup === 'function'
      ) {
        modal.closeProductPopup();
        await new Promise((r) => setTimeout(r, 200));
      }
      var additionalModal = document.querySelector('.product-popup-modal--additional');
      if (additionalModal) {
        if (typeof additionalModal.closeAdditionalPopup === 'function') {
          additionalModal.closeAdditionalPopup();
        } else {
          additionalModal.classList.remove('is-open');
          document.documentElement.classList.remove('no-scroll');
          document.body.classList.remove('no-scroll');
        }
      }
    }
    await openCartDrawer();
  }

  function setAtcDisabled(form, disabled) {
    const btn =
      document.querySelector(`[form="${CSS.escape(form.id)}"][type="submit"]`) ||
      form.querySelector('[type="submit"][name="add"]') ||
      form.querySelector('[type="submit"]');

    if (!btn) return;

    if (disabled) {
      btn.dataset.bundlePrevDisabled = btn.hasAttribute('disabled') ? '1' : '0';
      btn.dataset.bundlePrevAria = btn.getAttribute('aria-disabled') || '';

      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    } else {
      const prevDisabled = btn.dataset.bundlePrevDisabled === '1';
      const prevAria = btn.dataset.bundlePrevAria;

      if (prevDisabled) {
        btn.setAttribute('disabled', 'disabled');
        if (prevAria) btn.setAttribute('aria-disabled', prevAria);
        else btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        if (prevAria) btn.setAttribute('aria-disabled', prevAria);
        else btn.removeAttribute('aria-disabled');
      }

      delete btn.dataset.bundlePrevDisabled;
      delete btn.dataset.bundlePrevAria;
    }
  }

  function setAtcLoading(form, loading) {
    const btn =
      document.querySelector(`[form="${CSS.escape(form.id)}"][type="submit"]`) ||
      form.querySelector('[type="submit"][name="add"]') ||
      form.querySelector('[type="submit"]');

    if (!btn) return;

    btn.dataset.bundleLoading = loading ? '1' : '0';
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  async function handleAddToCart(root, form) {
    if (form.dataset.bundleAdding === '1') return;
    form.dataset.bundleAdding = '1';

    const productJson = getProductJson(root);
    if (!productJson) {
      form.dataset.bundleAdding = '';
      alert(
        "bundle-product-json not found. Make sure <script class='bundle-product-json'> exists INSIDE .bundle-picker"
      );
      return;
    }

    const bundle = root.querySelector('input[name="properties[_bundle]"]')?.value || 'single';
    const is2plus1 = bundle === 'two_plus_one';
    const isPopup21 = root.dataset.popup === 'true' && bundle === 'two_plus_one';

    if (isPopup21) {
      const c1 = (root.querySelector('input[name="properties[_bundle_color_1]"]')?.value || getDefaultColor(root)).trim();
      const c2 = (root.querySelector('input[name="properties[_bundle_color_2]"]')?.value || getDefaultColor(root)).trim();
      const c3 = (root.querySelector('input[name="properties[_bundle_color_3]"]')?.value || getDefaultColor(root)).trim();
      const size = getDefaultSizeForPopup21(root, productJson);
      if (!size) {
        form.dataset.bundleAdding = '';
        alert('Please select a size.');
        return;
      }
      const offer21 = getOffer2Plus1Value(productJson);
      const comboLabel =
        (root._popup21Combos && root._popup21Combos.find((x) => x.c1 === c1 && x.c2 === c2 && x.c3 === c3))
          ?.label || (c1 === c2 && c2 === c3 ? '3' + c1 : [c1, c2, c3].join('-'));
      const optionNames = getOptionNames(productJson);
      const offerIndex = findOfferOptionIndex(productJson);
      const offerOptionName = offerIndex >= 0 ? optionNames[offerIndex] || 'Offer' : null;
      const colorIndex = findColorOptionIndex(productJson);
      const sizeIndex = findSizeOptionIndex(productJson);
      let variant = findVariantByFarbeLabelSizeOffer(productJson, comboLabel, size, offer21);
      if (!variant) {
        const v1 = findVariant21(productJson, c1, size, offer21);
        const v2 = findVariant21(productJson, c2, size, offer21);
        const v3 = findVariant21(productJson, c3, size, offer21);
        if (!v1 || !v2 || !v3) {
          form.dataset.bundleAdding = '';
          alert('Variant not found. Please select size and color.');
          return;
        }
        variant = v1;
      }
      const bundleTotalPrice = get2plus1BundlePriceFromDOM(root);
      const pricePerItem = bundleTotalPrice > 0 ? bundleTotalPrice / 3 : 0;
      const groupToken = Date.now() + '_' + Math.random().toString(16).slice(2);
      const items = [];
      const properties = {};
      if (offerOptionName) properties[offerOptionName] = offer21;
      if (optionNames[colorIndex]) properties[optionNames[colorIndex]] = comboLabel;
      if (optionNames[sizeIndex]) properties[optionNames[sizeIndex]] = String(size);
      properties._bundle = 'two_plus_one';
      properties._bundle_group = groupToken;
      properties._bundle_item = '1';
      if (pricePerItem > 0) {
        properties._bundle_total_price = String(bundleTotalPrice.toFixed(2));
        properties._bundle_unit_price = String(pricePerItem.toFixed(2));
        properties['Price'] = '$' + pricePerItem.toFixed(2);
      }
      items.push({ id: Number(variant.id), quantity: 1, properties });
      const atcBtn =
        form.querySelector('[type="submit"]') ||
        document.querySelector('[form="' + CSS.escape(form.id) + '"][type="submit"]');
      if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
      try {
        for (const item of items) await addItems([item]);
        await openAdditionalPopupOrCart(items, root);
      } catch (e) {
        console.error(e);
        alert(e?.message || String(e) || 'Add to cart failed.');
        if (atcBtn) atcBtn.removeAttribute('disabled');
      }
      form.dataset.bundleAdding = '';
      return;
    }

    if (is2plus1) {
      const rows = qsa(root, '.bundle-item');
      const colors = [];
      for (let i = 0; i < 3; i++) {
        const row = rows[i];
        const swatch = row && row.querySelector('.bundle-fixed-swatch[aria-pressed="true"]');
        const color = swatch
          ? (swatch.dataset.color || swatch.dataset.comboId || '').trim()
          : root.querySelector('input[name="' + CSS.escape('properties[_bundle_color_' + (i + 1) + ']') + '"]')
              ?.value || getDefaultColor(root);
        colors.push(color || getDefaultColor(root));
      }
      let size = ((qs(root, '.bundle-items__size') && qs(root, '.bundle-items__size').textContent) || '').trim();
      if (!size) {
        const vid = getCurrentVariantIdFromForm(form);
        const v = vid ? (productJson.variants || []).find((x) => Number(x.id) === Number(vid)) : null;
        const sizeIdx = findSizeOptionIndex(productJson);
        if (v) size = [v.option1, v.option2, v.option3][sizeIdx] || '';
      }
      const colorIndex = findColorOptionIndex(productJson);
      const sizeIndex = findSizeOptionIndex(productJson);
      const optionNames = getOptionNames(productJson);
      const optionCount = (productJson.options || []).length || 1;
      const bundleTotalPrice = get2plus1BundlePriceFromDOM(root);
      const pricePerItem = bundleTotalPrice > 0 ? bundleTotalPrice / 3 : 0;

      // 250-variant bypass: if a real combo variant exists (color like "Black-White-Beige"),
      // add it as ONE line item instead of three separate ones. No-op until the
      // custom.bundle_combo_lookup metafield is generated (then this path takes over).
      const offer21ForCombo = getOffer2Plus1Value(productJson);
      const comboId21 = findComboVariantId(productJson, offer21ForCombo, colors, size);
      if (comboId21) {
        const comboLabel21 = colors.join('-');
        const comboProps = {};
        if (offer21ForCombo && optionNames[findOfferOptionIndex(productJson)])
          comboProps[optionNames[findOfferOptionIndex(productJson)]] = offer21ForCombo;
        if (optionNames[colorIndex]) comboProps[optionNames[colorIndex]] = comboLabel21;
        if (optionNames[sizeIndex]) comboProps[optionNames[sizeIndex]] = String(size);
        comboProps._bundle = 'two_plus_one';
        comboProps._cb_colors = colors.join(', ');
        // Combo variants live beyond the 250-variant window, so the cart drawer (UpCart)
        // can't read their compare_at_price from products/{handle}.js. Pass the whole-bundle
        // totals from the lookup metafield as hidden line-item properties instead.
        {
          const t21 = getComboOfferTotals(productJson, offer21ForCombo);
          if (t21) {
            if (t21.compareCents > 0) comboProps._compare_at_price = String(t21.compareCents);
            if (t21.priceCents > 0) comboProps._price = String(t21.priceCents);
          }
        }
        // Free gift is added automatically by the store's gift app — do NOT add it here.
        const comboItems = [{ id: Number(comboId21), quantity: 1, properties: comboProps }];
        const atcBtnC =
          form.querySelector('[type="submit"]') ||
          document.querySelector('[form="' + CSS.escape(form.id) + '"][type="submit"]');
        if (atcBtnC) atcBtnC.setAttribute('disabled', 'disabled');
        try {
          await addItems(comboItems);
          await openAdditionalPopupOrCart(comboItems, root);
        } catch (e) {
          console.error(e);
          alert(e?.message || String(e) || 'Add to cart failed.');
          if (atcBtnC) atcBtnC.removeAttribute('disabled');
        }
        form.dataset.bundleAdding = '';
        return;
      }

      const items = [];
      for (let i = 0; i < 3; i++) {
        const wanted = [];
        for (let j = 0; j < optionCount; j++) {
          wanted[j] = j === colorIndex ? colors[i] : j === sizeIndex ? size : '';
        }
        let v = findVariantByOptions(productJson, wanted);
        if (!v && optionCount >= 2) {
          v =
            (productJson.variants || []).find((x) => {
              const c = [x.option1, x.option2, x.option3][colorIndex];
              const s = [x.option1, x.option2, x.option3][sizeIndex];
              return String(c) === String(colors[i]) && String(s) === String(size);
            }) || null;
        }
        if (!v) {
          form.dataset.bundleAdding = '';
          alert('Variant not found: ' + colors[i] + ' / ' + size + '. Please select a size.');
          return;
        }
        const properties = {};
        if (optionNames[colorIndex]) properties[optionNames[colorIndex]] = String(colors[i]);
        if (optionNames[sizeIndex]) properties[optionNames[sizeIndex]] = String(size);
        properties._bundle = 'two_plus_one';
        properties._bundle_item = String(i + 1);
        if (pricePerItem > 0) {
          properties._bundle_total_price = String(bundleTotalPrice.toFixed(2));
          properties._bundle_unit_price = String(pricePerItem.toFixed(2));
          properties['Price'] = '$' + pricePerItem.toFixed(2);
        }
        items.push({ id: Number(v.id), quantity: 1, properties });
      }
      const atcBtn =
        form.querySelector('[type="submit"]') ||
        document.querySelector('[form="' + CSS.escape(form.id) + '"][type="submit"]');
      if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
      try {
        for (const item of items) await addItems([item]);
        await openAdditionalPopupOrCart(items, root);
      } catch (e) {
        console.error(e);
        alert(e?.message || String(e) || 'Add to cart failed.');
        if (atcBtn) atcBtn.removeAttribute('disabled');
      }
      form.dataset.bundleAdding = '';
      return;
    }

    // ——— single / 1+1 ———
    const count = getBundleCount(bundle);
    const optionNames = getOptionNames(productJson);
    const colorIndex = findColorOptionIndex(productJson);
    const sizeIndex = findSizeOptionIndex(productJson);
    const groupToken = Date.now() + '_' + Math.random().toString(16).slice(2);
    const items = [];

    const isPopup11 = root.dataset.popup === 'true' && bundle === 'one_plus_one';
    if (isPopup11) {
      const c1 = (root.querySelector('input[name="properties[_bundle_color_1]"]')?.value || getDefaultColor(root)).trim();
      const c2 = (root.querySelector('input[name="properties[_bundle_color_2]"]')?.value || getDefaultColor(root)).trim();
      const size = getDefaultSizeForPopup11(root, productJson);
      if (!size) {
        form.dataset.bundleAdding = '';
        alert('Please select a size.');
        return;
      }
      const offer1 = getOffer1Plus1Value(productJson);
      const comboLabel =
        (root._popup11Combos && root._popup11Combos.find((x) => x.c1 === c1 && x.c2 === c2))?.label ||
        (c1 === c2 ? '2' + c1 : c1 + '-' + c2);
      const offerIndex = findOfferOptionIndex(productJson);
      const offerOptionName = offerIndex >= 0 ? optionNames[offerIndex] || 'Offer' : null;
      let variant = findVariantByFarbeLabelSizeOffer(productJson, comboLabel, size, offer1);
      if (!variant) {
        const v1 = findVariant11(productJson, c1, size, offer1);
        const v2 = findVariant11(productJson, c2, size, offer1);
        if (!v1 || !v2) {
          form.dataset.bundleAdding = '';
          alert('Variant not found. Please select size and color.');
          return;
        }
        variant = v1;
      }
      const properties = {};
      if (offerOptionName) properties[offerOptionName] = offer1;
      if (optionNames[colorIndex]) properties[optionNames[colorIndex]] = comboLabel;
      if (optionNames[sizeIndex]) properties[optionNames[sizeIndex]] = String(size);
      properties._bundle = bundle;
      properties._bundle_group = groupToken;
      properties._bundle_item = '1';
      items.push({ id: Number(variant.id), quantity: 1, properties });
    } else {
      // 250-variant bypass for 1+1: add the single combo variant (e.g. "Black-White")
      // as ONE line item when it exists in the lookup metafield; otherwise fall
      // through to the existing per-color logic below. No-op until the metafield
      // (custom.bundle_combo_lookup) is generated.
      if (bundle === 'one_plus_one') {
        const comboColors = getSelectedBundleColors(root, 2);
        let comboSize = (qs(root, '.bundle-items__size')?.textContent || '').trim();
        if (!comboSize) comboSize = getSelectedSizeFromForm(productJson, form);
        const offer1ForCombo = getOffer1Plus1Value(productJson);
        const comboId11 = findComboVariantId(productJson, offer1ForCombo, comboColors, comboSize);
        if (comboId11) {
          const offerIdx11 = findOfferOptionIndex(productJson);
          const comboProps = {};
          if (offer1ForCombo && optionNames[offerIdx11]) comboProps[optionNames[offerIdx11]] = offer1ForCombo;
          if (optionNames[colorIndex]) comboProps[optionNames[colorIndex]] = comboColors.join('-');
          if (optionNames[sizeIndex]) comboProps[optionNames[sizeIndex]] = String(comboSize);
          comboProps._bundle = bundle;
          comboProps._cb_colors = comboColors.join(', ');
          // Pass whole-bundle totals so the cart drawer can show compare/savings for the
          // combo variant (it's past the 250-variant window of products/{handle}.js).
          {
            const t11 = getComboOfferTotals(productJson, offer1ForCombo);
            if (t11) {
              if (t11.compareCents > 0) comboProps._compare_at_price = String(t11.compareCents);
              if (t11.priceCents > 0) comboProps._price = String(t11.priceCents);
            }
          }
          items.push({ id: Number(comboId11), quantity: 1, properties: comboProps });
          const atcBtnC =
            form.querySelector('[type="submit"]') ||
            document.querySelector('[form="' + CSS.escape(form.id) + '"][type="submit"]');
          if (atcBtnC) atcBtnC.setAttribute('disabled', 'disabled');
          try {
            await addItems(items);
            await openAdditionalPopupOrCart(items, root);
            if (atcBtnC) atcBtnC.removeAttribute('disabled');
          } catch (e) {
            console.error(e);
            alert('Add to cart failed.');
            if (atcBtnC) atcBtnC.removeAttribute('disabled');
          }
          form.dataset.bundleAdding = '';
          return;
        }
      }
      const currentVariantId = getCurrentVariantIdFromForm(form);
      if (!currentVariantId) {
        form.dataset.bundleAdding = '';
        alert('No variant id found in form.');
        return;
      }
      const currentVariant = (productJson.variants || []).find((v) => Number(v.id) === Number(currentVariantId));
      if (!currentVariant) {
        form.dataset.bundleAdding = '';
        alert('Selected variant not found.');
        return;
      }
      for (let i = 1; i <= count; i++) {
        const row = qsa(root, '.bundle-item')[i - 1];
        const swatch = row && row.querySelector('.bundle-fixed-swatch[aria-pressed="true"]');
        const color = (swatch?.dataset?.color || swatch?.dataset?.comboId || getDefaultColor(root)).trim();
        let size = (qs(root, '.bundle-items__size')?.textContent || '').trim();
        if (!size) size = getSelectedSizeFromForm(productJson, form);
        if (!size) {
          form.dataset.bundleAdding = '';
          alert('Please select a size.');
          return;
        }
        const v = findVariantByColorAndSize(productJson, color, size);
        if (!v) {
          form.dataset.bundleAdding = '';
          alert(`Variant not found: ${color} / ${size}`);
          return;
        }
        const properties = {};
        if (optionNames[colorIndex]) properties[optionNames[colorIndex]] = String(color);
        if (optionNames[sizeIndex]) properties[optionNames[sizeIndex]] = String(size);
        properties._bundle = bundle;
        properties._bundle_group = groupToken;
        properties._bundle_item = String(i);
        items.push({ id: Number(v.id), quantity: 1, properties });
      }
    }

    const atcBtn =
      form.querySelector('[type="submit"]') ||
      document.querySelector('[form="' + CSS.escape(form.id) + '"][type="submit"]');
    if (atcBtn) atcBtn.setAttribute('disabled', 'disabled');
    try {
      await addItems(items);
      await openAdditionalPopupOrCart(items, root);
      if (atcBtn) atcBtn.removeAttribute('disabled');
    } catch (e) {
      console.error(e);
      alert('Add to cart failed.');
      if (atcBtn) atcBtn.removeAttribute('disabled');
    }
    form.dataset.bundleAdding = '';
  }

  // ---------- Robust form detection + binding ----------
  function findProductForm(root) {
    const bundleInput = qs(root, 'input[name="properties[_bundle]"]');
    const formId = bundleInput?.getAttribute('form');

    if (formId) {
      const byId = document.getElementById(formId);
      if (byId && byId.tagName === 'FORM') return byId;

      const byQuery = document.querySelector(`form#${CSS.escape(formId)}`);
      if (byQuery) return byQuery;
    }

    const scope = root.closest('product-info') || document;
    const pf = scope.querySelector('product-form form');
    if (pf) return pf;

    const closest = root.closest('form');
    if (closest) return closest;

    return null;
  }

  /** Sync popup form submit button (disabled/text) from current variant; call after open or after product:rerender. */
  function syncPopupFormSubmitButton(picker, form, productJson) {
    if (!form || !productJson) return;
    const idInput = form.querySelector('input[name="id"]');
    const variantId = idInput && idInput.value ? String(idInput.value).trim() : '';
    const variant =
      variantId && productJson.variants
        ? productJson.variants.find(function (v) {
            return String(v.id) === variantId;
          })
        : null;
    const submitBtn =
      form.querySelector('buy-buttons button[type="submit"]') ||
      form.querySelector('buy-buttons [type="submit"]') ||
      form.querySelector('button[type="submit"]');
    if (!submitBtn) return;
    const available = variant ? variant.available !== false : false;
    const variantRoot = picker ? picker.querySelector('[data-popup-variant]') : null;
    const addText = (variantRoot && variantRoot.getAttribute('data-add-to-cart')) || 'Add to cart';
    const soldOutText = (variantRoot && variantRoot.getAttribute('data-sold-out')) || 'Sold out';
    submitBtn.disabled = !available;
    submitBtn.setAttribute('aria-disabled', String(!available));
    submitBtn.textContent = available ? addText : soldOutText;
    submitBtn.classList.toggle('button--subdued', !available);
  }

  /** Fire change on the currently checked variant radio in the popup so popup-variant.liquid listener updates the button. */
  function triggerCheckedVariantChange(picker) {
    if (!picker) return;
    const variantRoot = picker.querySelector('[data-popup-variant]');
    if (!variantRoot) return;
    const radio = variantRoot.querySelector('input[type="radio"]:checked');
    if (radio) radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindOnce(root, form) {
    if (form.dataset.bundlePickerBound === '1') return;
    form.dataset.bundlePickerBound = '1';

    function interceptSubmit(e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      if (form.dataset.bundleSubmitHandled === '1') return false;
      form.dataset.bundleSubmitHandled = '1';
      handleAddToCart(root, form).finally(function () {
        form.dataset.bundleSubmitHandled = '';
      });
      return false;
    }
    form.addEventListener('submit', interceptSubmit, true);

    document.addEventListener(
      'submit',
      function (e) {
        if (e.target === form) interceptSubmit(e);
      },
      true
    );
  }

  function init(root) {
    injectCssOnce();
    const isPopup = root.dataset.popup === 'true';
    const scopedRoot = root.closest('product-info') || root.closest('.shopify-section') || root;
    const variantScript =
      scopedRoot.querySelector('[data-variants-json]') || document.querySelector('[data-variants-json]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];

    // Stock lookup by variant id from data-variants-json. This is the ONLY source
    // that carries real inventory_quantity / inventory_policy: {{ product | json }}
    // (i.e. getProductJson()/bundle-product-json) does NOT serialize those fields.
    // The combo preorder branch resolves single-color variants off pj.variants (which
    // therefore lack stock data), so it must re-hydrate their stock through this map —
    // otherwise soldOutSellable() is always false and preorder never shows in a bundle.
    const stockById = new Map();
    variants.forEach((v) => {
      if (v && v.id != null) stockById.set(Number(v.id), v);
    });
    function resolveVariantStock(v, pj) {
      if (!v || v.id == null) return v || null;
      const hit = stockById.get(Number(v.id));
      if (hit) return hit;
      // Beyond the first-250 variant window: fall back to the bundle_combo_stock
      // metafield ({ variantId: {q,p,m} } — q=qty, p=policy, m=management).
      const cs =
        pj && pj.__comboStock && (pj.__comboStock[String(v.id)] || pj.__comboStock[Number(v.id)]);
      if (cs) {
        return {
          id: v.id,
          available: v.available,
          inventory_quantity: cs.q != null ? cs.q : cs.inventory_quantity,
          inventory_policy: cs.p != null ? cs.p : cs.inventory_policy,
          inventory_management: cs.m != null ? cs.m : cs.inventory_management,
        };
      }
      return v;
    }

    const form_newform =
      scopedRoot.querySelector('.product-info__buy-buttons form') ||
      document.querySelector('.product-info__buy-buttons form');
    const idInput = form_newform ? form_newform.querySelector('[name="id"]') : null;

    function getCurrentVariantStockNotice() {
      if (!idInput || !variants.length) return null;

      const selectedId = Number(idInput.value);
      if (!selectedId) return null;

      const matchedVariant = variants.find((v) => v.id === selectedId);
      if (!matchedVariant) return null;

      return matchedVariant.stock_notice || '';
    }
    function getCurrentVariantData() {
      if (!idInput || !variants.length) return null;

      const selectedId = Number(idInput.value);
      if (!selectedId) return null;

      const matchedVariant = variants.find((v) => v.id === selectedId);
      if (!matchedVariant) return null;

      return {
        id: selectedId,
        stock_notice: matchedVariant.stock_notice || '',
        inventory_quantity: matchedVariant.inventory_quantity,
        inventory_management: matchedVariant.inventory_management,
        inventory_policy: matchedVariant.inventory_policy,
        available: matchedVariant.available,
      };
    }
    function updateStockNoticeUI(targetSelector) {
      const notice = getCurrentVariantStockNotice();
      if (notice === null) return;

      const container = scopedRoot.querySelector(targetSelector) || document.querySelector(targetSelector);
      if (container) {
        container.textContent = notice;
      }
    }
    const buyArea =
      scopedRoot.querySelector('.product-info__buy-area') || document.querySelector('.product-info__buy-area');
    if (!buyArea) return;
    const braPickerHost = scopedRoot.querySelector('.bra-size-picker');
    const bundleSizeContainer = scopedRoot.querySelector('.bundle_size');
    const noticeHost = braPickerHost || bundleSizeContainer || buyArea;

    let notice = null;
    if (!isPopup) {
      notice = noticeHost.querySelector('#stock-notice') || document.getElementById('stock-notice');
    }

    if (!isPopup && !notice) {
      notice = document.createElement('p');
      notice.id = 'stock-notice';
      notice.style.cssText = 'margin:0 0 8px;font-size:14px;display:none;align-items:center;';
      if (braPickerHost && braPickerHost.parentElement) {
        braPickerHost.insertAdjacentElement('afterend', notice);
      } else {
        noticeHost.prepend(notice);
      }
    }
    if (!isPopup && notice) {
      if (braPickerHost && braPickerHost.parentElement) {
        if (
          notice.previousElementSibling !== braPickerHost ||
          notice.parentElement !== braPickerHost.parentElement
        ) {
          braPickerHost.insertAdjacentElement('afterend', notice);
        }
      } else if (notice.parentElement !== noticeHost) {
        noticeHost.prepend(notice);
      }
    }
    if (notice) {
      notice.style.display = 'none';
      notice.innerHTML = '';
    }
    function renderNotice(text, color) {
      if (!notice) return;
      if (!text || !color) {
        notice.innerHTML = '';
        notice.style.color = '';
        notice.style.display = 'none';
        return;
      }

      notice.innerHTML = `
        <span style="
          display:inline-block;
          width:8px;height:8px;
          border-radius:50%;
          background:${color};
          margin-right:6px;
          flex-shrink:0;
        "></span>${text}
      `;

      notice.style.color = color;
      notice.style.display = 'flex';
    }
    if (isPopup) renderNotice('', '');

    function getFallbackStockNotice(variantData) {
      if (!variantData) return null;
      if (variantData.inventory_management == null) {
        return { text: 'In Stock – available', color: '#43aa39' };
      }

      const qty = Number(variantData.inventory_quantity || 0);

      if (qty > 3) {
        return { text: 'In Stock – available', color: '#43aa39' };
      }

      if (qty > 0) {
        return { text: 'Almost sold out – available', color: '#ffa500' };
      }

      // Sold out / zero qty: do not show stock notice.
      return null;
    }

    let combinedSizeChosenByUser = false;
    let combinedSizeWasEverFilled = false;

    function getVariantDataFromUrl() {
      if (!variants.length) return null;
      const urlVariantId = Number(getVariantIdFromUrl());
      if (!urlVariantId) return null;
      const matchedVariant = variants.find((v) => Number(v.id) === urlVariantId);
      if (!matchedVariant) return null;
      return {
        id: urlVariantId,
        stock_notice: matchedVariant.stock_notice || '',
        inventory_quantity: matchedVariant.inventory_quantity,
        inventory_management: matchedVariant.inventory_management,
        inventory_policy: matchedVariant.inventory_policy,
        available: matchedVariant.available,
      };
    }

    function syncStockNoticeAndPreorder() {
      if (isPopup) {
        renderNotice('', '');
        return;
      }
      const submitBtn =
        scopedRoot.querySelector('.product-info__buy-buttons buy-buttons button[type="submit"]') ||
        scopedRoot.querySelector('.product-info__buy-buttons button[type="submit"]') ||
        document.querySelector('.product-info__buy-buttons buy-buttons button[type="submit"]');
      const isAtcReady = !!submitBtn && !submitBtn.disabled && submitBtn.getAttribute('aria-disabled') !== 'true';
      if (!isAtcReady) {
        renderNotice('', '');
        return;
      }

      // Combo offers (1+1 / 2+1): the combo variant added to cart oversells, so real
      // availability comes from the SELECTED colors' single-color variants at the chosen
      // size (all rows, not just the first). Preorder replaces the stock notice when ANY
      // selected color is out of stock but still sellable (qty<=0, policy continue).
      const comboBundleKey = getBundleKeyFromRoot(root);
      if (comboBundleKey === 'one_plus_one' || comboBundleKey === 'two_plus_one') {
        const pj = getProductJson(root);
        const preorderBoxCombo =
          scopedRoot.querySelector('.product-info__buy-area .preorder-box') ||
          document.querySelector('.product-info__buy-area .preorder-box');
        if (!pj) {
          if (preorderBoxCombo) preorderBoxCombo.setAttribute('hidden', '');
          return;
        }
        const count = comboBundleKey === 'one_plus_one' ? 2 : 3;
        const colors = getSelectedBundleColors(root, count);
        let size = (scopedRoot.querySelector('.bundle-items__size')?.textContent || '').trim();
        if (!size) size = getSelectedSizeFromForm(pj, form) || '';
        if (!size || colors.filter(Boolean).length < count) {
          // Not enough info yet (no size / not all colors chosen) — leave as-is, no flicker.
          return;
        }
        const parts = colors.map((c) => {
          // pj.variants have no inventory fields ({{ product | json }} omits them),
          // so re-hydrate each resolved single-color variant's stock by id.
          const v = findVariantByOfferSizeColor(pj, 'single', size, c) || findVariantByColorAndSize(pj, c, size);
          return resolveVariantStock(v, pj);
        });
        const soldOutSellable = (v) =>
          v &&
          String(v.inventory_management || '') === 'shopify' &&
          Number.isFinite(Number(v.inventory_quantity)) &&
          Number(v.inventory_quantity) <= 0 &&
          String(v.inventory_policy || '') === 'continue';
        const anyPreorder = parts.some((v) => soldOutSellable(v));

        if (anyPreorder) {
          // Out of stock but sellable → show preorder INSTEAD of the stock notice.
          renderNotice('', '');
          if (preorderBoxCombo) preorderBoxCombo.removeAttribute('hidden');
        } else {
          // In stock → stock notice (scarcest selected color), preorder hidden.
          let aggregate = null;
          if (parts.every(Boolean)) {
            const managed = parts.filter((v) => String(v.inventory_management || '') === 'shopify');
            aggregate =
              managed.length === 0
                ? { inventory_management: null }
                : {
                    inventory_management: 'shopify',
                    inventory_quantity: Math.min(...managed.map((v) => Number(v.inventory_quantity || 0))),
                    inventory_policy: 'continue',
                  };
          }
          const fb = aggregate ? getFallbackStockNotice(aggregate) : null;
          if (fb) renderNotice(fb.text, fb.color);
          else renderNotice('', '');
          if (preorderBoxCombo) preorderBoxCombo.setAttribute('hidden', '');
        }
        return;
      }

      let variantData = null;
      const scopedBraPicker =
        scopedRoot.querySelector('.bra-size-picker') || scopedRoot.querySelector('.bra-size-dropdowns');
      if (scopedBraPicker) {
        const combinedSizeInput =
          scopedBraPicker.querySelector('#combined-size') ||
          scopedBraPicker.querySelector('input[name="options[Größe]"]') ||
          scopedBraPicker.querySelector('input[name="options[Size]"]');
        const hasFinalSize = !!(combinedSizeInput && String(combinedSizeInput.value || '').trim() !== '');

        if (hasFinalSize) combinedSizeWasEverFilled = true;

        if (!combinedSizeChosenByUser) {
          renderNotice('', '');
          return;
        }

        // After user interacted once:
        // - prefer final combined-size variant
        // - if combined-size got cleared, fallback to URL variant id
        variantData = hasFinalSize
          ? getCurrentVariantData()
          : combinedSizeWasEverFilled
          ? getVariantDataFromUrl()
          : null;
        if (!variantData) {
          renderNotice('', '');
          return;
        }
      }

      variantData = variantData || getCurrentVariantData();
      if (!variantData) return;

      const preorderBox =
        scopedRoot.querySelector('.product-info__buy-area .preorder-box') ||
        document.querySelector('.product-info__buy-area .preorder-box');

      if (variantData.stock_notice == 'In Stock - available') {
        renderNotice('In Stock - available', '#43aa39');
      } else if (variantData.stock_notice == 'Almost sold out - available') {
        renderNotice('Almost sold out - available', '#ffa500');
      } else {
        const fallbackNotice = getFallbackStockNotice(variantData);
        if (fallbackNotice) {
          renderNotice(fallbackNotice.text, fallbackNotice.color);
        } else {
          renderNotice('', '');
        }
      }

      const qty = Number(variantData.inventory_quantity);
      const canShowPreorder =
        String(variantData.inventory_management || '') === 'shopify' &&
        Number.isFinite(qty) &&
        qty <= 0 &&
        String(variantData.inventory_policy || '') === 'continue';

      if (preorderBox) {
        if (canShowPreorder) preorderBox.removeAttribute('hidden');
        else preorderBox.setAttribute('hidden', '');
      }
    }

    const form = findProductForm(root);
    if (!form) {
      console.warn('[BundlePicker] Could not find product form for bundle picker.');
      return;
    }
    bindOnce(root, form);

    const cards = qsa(root, '.bundle-card');
    const bundleHidden = qs(root, 'input[name="properties[_bundle]"]');
    const productJson = getProductJson(root);

    const firstOfferBundle = cards[0]?.dataset.bundle || 'single';
    let initialDisplayBundle = 'single';
    const forceInitialSingleVariant = root.dataset.initialSinglePrice === 'true' && !isPopup;
    if (forceInitialSingleVariant) root.dataset.initialSinglePriceUnlocked = '0';

    let currentBundle = initialDisplayBundle;
    let didInitialAutoVariantSet = false;

    const shouldForceInitialOnePlusOneVisual = !isPopup && root.dataset.initialSinglePrice === 'true';
    if (shouldForceInitialOnePlusOneVisual) {
      root.classList.add('bundle-picker--initial-one-plus-one');
    }

    if (productJson && form && !isPopup) {
      const urlVariantId = getVariantIdFromUrl();
      const urlVariant =
        urlVariantId && productJson.variants
          ? productJson.variants.find((v) => String(v.id) === String(urlVariantId))
          : null;
      if (urlVariant) {
        const offerIndex = findOfferOptionIndex(productJson);
        const offerVal = String(
          [urlVariant.option1, urlVariant.option2, urlVariant.option3][offerIndex] || ''
        ).trim();
        const offer1 = getOffer1Plus1Value(productJson);
        const offer21 = getOffer2Plus1Value(productJson);
        if (offerVal === offer1) initialDisplayBundle = 'one_plus_one';
        else if (offerVal === offer21) initialDisplayBundle = 'two_plus_one';
        else initialDisplayBundle = 'single';
        const idFromUrlInput = form.querySelector('input[name="id"]');
        if (idFromUrlInput) idFromUrlInput.value = String(urlVariant.id);
      }
      const firstVariantId = getFirstVariantIdForBundle(productJson, firstOfferBundle);
      if (firstVariantId != null) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && String(idInput.value) !== String(firstVariantId) && !urlVariantId) {
          idInput.value = String(firstVariantId);
        }
      }

      // Requested behavior:
      // - visual bundle stays 1+1 on first render
      // - variant id in URL/value should be from SINGLE for correct initial price
      if (forceInitialSingleVariant) {
        initialDisplayBundle = 'one_plus_one';
        const singleVariant = getFirstAvailableVariantForOffer(productJson, 'single');
        const idInput = form.querySelector('input[name="id"]');
        if (singleVariant && idInput) {
          idInput.value = String(singleVariant.id);
          setVariantInUrl(singleVariant.id);
          didInitialAutoVariantSet = true;
        }
      }
    }

    let keepInitialSinglePrice = root.dataset.initialSinglePrice === 'true';
    const lockedSingleVariant =
      keepInitialSinglePrice && productJson ? getFirstAvailableVariantForOffer(productJson, 'single') : null;

    function setBundle(bundle, isUserClick) {
      currentBundle = bundle;
      if (isUserClick) {
        keepInitialSinglePrice = false;
        root.dataset.initialSinglePriceUnlocked = '1';
        root.classList.remove('bundle-picker--initial-one-plus-one');
      }
      const effectiveBundleForInit = keepInitialSinglePrice && !isUserClick ? 'single' : bundle;

      cards.forEach((c) => c.setAttribute('aria-checked', c.dataset.bundle === bundle ? 'true' : 'false'));
      const isInitialAutoRender = !isUserClick && root.dataset.initialVisualCheckedApplied !== '1';
      if (isInitialAutoRender || (keepInitialSinglePrice && !isUserClick)) {
        cards.forEach((c) =>
          c.setAttribute('aria-checked', c.dataset.bundle === 'one_plus_one' ? 'true' : 'false')
        );
      }
      if (isInitialAutoRender) root.dataset.initialVisualCheckedApplied = '1';
      cards.forEach((c) => c.classList.remove('bundle-card--visual-highlight'));
      if (keepInitialSinglePrice && !isUserClick) {
        const visualCard = cards.find((c) => c.dataset.bundle === 'one_plus_one');
        if (visualCard) visualCard.classList.add('bundle-card--visual-highlight');
      }
      if (bundleHidden) bundleHidden.value = bundle;

      updateUnlockUI(root, bundle);
      renderItems(root, bundle);

      if (!isPopup && productJson && form && !isUserClick && !didInitialAutoVariantSet) {
        const firstVariant = getFirstAvailableVariantForOffer(productJson, effectiveBundleForInit);
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && firstVariant && String(idInput.value) !== String(firstVariant.id)) {
          idInput.value = String(firstVariant.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          setVariantInUrl(firstVariant.id);
        }
        didInitialAutoVariantSet = true;
      }

      // On real offer click, always switch main variant to that offer.
      if (!isPopup && productJson && form && isUserClick) {
        const offerVariant = getFirstAvailableVariantForOffer(productJson, bundle);
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && offerVariant && String(idInput.value) !== String(offerVariant.id)) {
          idInput.value = String(offerVariant.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          setVariantInUrl(offerVariant.id);
        }
      }

      if (isPopup && productJson && form) {
        applyPopupSizeFilter(root, bundle);
        const firstVariant = getFirstAvailableVariantForOffer(productJson, bundle);
        const vid = firstVariant ? firstVariant.id : null;
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && vid != null) {
          idInput.value = String(vid);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          setVariantInUrl(vid);
          const variantRoot = root.querySelector('[data-popup-variant]');
          if (variantRoot) {
            const radio = variantRoot.querySelector('input[type="radio"][data-variant-id="' + String(vid) + '"]');
            if (radio && !radio.disabled) {
              radio.checked = true;
              variantRoot.querySelectorAll('.popup-variant__label').forEach(function (l) {
                l.classList.remove('popup-variant__label--selected');
              });
              const label = variantRoot.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
              if (label) label.classList.add('popup-variant__label--selected');
              const legend = variantRoot.querySelector('.popup-variant__legend');
              if (legend && label) {
                const optName = variantRoot.getAttribute('data-option-name') || 'Größe';
                legend.textContent = optName + ': ' + (label.textContent || '').trim();
              }
            }
          }
        } else if (idInput && !vid) {
          idInput.value = '';
          setVariantInUrl(null);
        }
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => updatePopupPriceForBundle(root, bundle));
      });
      if (!isPopup) {
        setTimeout(() => syncMainPriceFromOffer(root, effectiveBundleForInit), 0);
        setTimeout(() => syncMainPriceFromOffer(root, effectiveBundleForInit), 120);
        if (keepInitialSinglePrice) {
          setTimeout(() => syncMainPriceFromOffer(root, 'single'), 250);
        } else {
          setTimeout(() => syncMainPriceFromFormVariant(root, form, productJson, 'setBundle-nonlocked'), 250);
        }
        // Keep the stock-notice / preorder box in sync when switching bundles too
        // (renderItems re-renders the rows, so run after it settles).
        setTimeout(() => syncStockNoticeAndPreorder(), 60);
        setTimeout(() => syncStockNoticeAndPreorder(), 300);
      }

      // Avoid synthetic swatch clicks: they cause multiple intermediate variant URLs.
    }

    if (isPopup && productJson && form) {
      const urlVariantId = getVariantIdFromUrl();
      const urlVariant =
        urlVariantId && productJson.variants
          ? productJson.variants.find((v) => String(v.id) === String(urlVariantId))
          : null;
      if (urlVariant) {
        const offerIndex = findOfferOptionIndex(productJson);
        const offerVal = String(
          [urlVariant.option1, urlVariant.option2, urlVariant.option3][offerIndex] || ''
        ).trim();
        const offer1 = getOffer1Plus1Value(productJson);
        const offer21 = getOffer2Plus1Value(productJson);
        let bundleFromVariant = 'single';
        if (offerVal === offer1) bundleFromVariant = 'one_plus_one';
        else if (offerVal === offer21) bundleFromVariant = 'two_plus_one';
        currentBundle = bundleFromVariant;
        if (bundleHidden) bundleHidden.value = bundleFromVariant;
        cards.forEach((c) =>
          c.setAttribute('aria-checked', c.dataset.bundle === bundleFromVariant ? 'true' : 'false')
        );
        updateUnlockUI(root, bundleFromVariant);
        renderItems(root, bundleFromVariant);
        applyPopupSizeFilter(root, bundleFromVariant);
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = String(urlVariant.id);
        const variantRoot = root.querySelector('[data-popup-variant]');
        if (variantRoot) {
          const radio = variantRoot.querySelector(
            'input[type="radio"][data-variant-id="' + String(urlVariant.id) + '"]'
          );
          if (radio && !radio.disabled) {
            radio.checked = true;
            variantRoot.querySelectorAll('.popup-variant__label').forEach(function (l) {
              l.classList.remove('popup-variant__label--selected');
            });
            const label = variantRoot.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
            if (label) label.classList.add('popup-variant__label--selected');
            const legend = variantRoot.querySelector('.popup-variant__legend');
            if (legend && label) {
              const optName = variantRoot.getAttribute('data-option-name') || 'Größe';
              legend.textContent = optName + ': ' + (label.textContent || '').trim();
            }
          }
        }
        requestAnimationFrame(() => {
          requestAnimationFrame(() => updatePopupPriceForBundle(root, bundleFromVariant));
        });
      } else {
        setBundle('one_plus_one', false);
        const firstOfferVariant = getFirstAvailableVariantForOffer(productJson, 'single');
        if (firstOfferVariant && form) {
          const idInputInit = form.querySelector('input[name="id"]');
          if (idInputInit) idInputInit.value = String(firstOfferVariant.id);
        }
        requestAnimationFrame(() => {
          requestAnimationFrame(() => updatePopupPriceForBundle(root, 'one_plus_one'));
        });
      }
    } else {
      // Let the Liquid-rendered aria state paint once on first render,
      // then hand control back to the existing JS logic.
      if (!isPopup && root.dataset.initialSinglePrice === 'true') {
        setTimeout(() => setBundle(initialDisplayBundle, false), 0);
      } else {
        setBundle(initialDisplayBundle, false);
      }
    }

    // Hard-lock initial SINGLE price/variant briefly to avoid startup overwrites from app scripts.
    if (!isPopup && keepInitialSinglePrice && lockedSingleVariant && form) {
      const idInputBoot = form.querySelector('input[name="id"]');
      const lockState = { unlocked: false };
      const unlock = function () {
        if (lockState.unlocked) return;
        lockState.unlocked = true;
        keepInitialSinglePrice = false;
        root.dataset.initialSinglePriceUnlocked = '1';
      };
      root.addEventListener(
        'pointerdown',
        function (e) {
          if (e.isTrusted) unlock();
        },
        true
      );
      root.addEventListener(
        'keydown',
        function (e) {
          if (e.isTrusted) unlock();
        },
        true
      );

      const enforceSingle = function (reason) {
        if (lockState.unlocked || !idInputBoot) return;
        const wanted = String(lockedSingleVariant.id);
        if (String(idInputBoot.value || '') !== wanted) {
          idInputBoot.value = wanted;
          idInputBoot.dispatchEvent(new Event('change', { bubbles: true }));
        }
        setVariantInUrl(wanted);
        syncMainPriceFromOffer(root, 'single');
        // Force 'single' here — the selected offer is 1+1 (so ATC adds 1+1), but the
        // initial display must stay the single price until the user interacts.
        syncMainPriceFromFormVariant(root, form, productJson, reason || 'boot-lock', 'single');
      };

      enforceSingle('boot-lock-init');
      setTimeout(() => enforceSingle('boot-lock-120ms'), 120);
      setTimeout(() => enforceSingle('boot-lock-350ms'), 350);
      setTimeout(() => enforceSingle('boot-lock-700ms'), 700);
      setTimeout(() => unlock(), 1500);
    }

    if (isPopup) {
      function schedulePriceUpdate() {
        const bundle = root.querySelector('input[name="properties[_bundle]"]')?.value || 'single';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => updatePopupPriceForBundle(root, bundle));
        });
      }
      form.addEventListener('variant:change', schedulePriceUpdate);
      form.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[name="id"]')) schedulePriceUpdate();
      });
      root.addEventListener(
        'click',
        function (e) {
          if (!e.target.closest('.popup-variant__grid') && !e.target.closest('.popup-variant__label')) return;
          setTimeout(schedulePriceUpdate, 0);
        },
        true
      );
    }
    cards.forEach((card) =>
      card.addEventListener('click', (e) => setBundle(card.dataset.bundle, e.isTrusted === true))
    );
    if (!isPopup) {
      const idInputLock = form ? form.querySelector('input[name="id"]') : null;
      if (idInputLock && lockedSingleVariant) {
        idInputLock.addEventListener(
          'change',
          function () {
            if (!keepInitialSinglePrice) return;
            const wanted = String(lockedSingleVariant.id);
            const current = String(idInputLock.value || '');
            if (current !== wanted) {
              idInputLock.value = wanted;
              setVariantInUrl(wanted);
              syncMainPriceFromOffer(root, 'single');
            }
          },
          true
        );
      }

      if (idInputLock) {
        idInputLock.addEventListener(
          'change',
          function () {
            if (keepInitialSinglePrice) return;
            setTimeout(() => syncMainPriceFromFormVariant(root, form, productJson, 'id-change'), 0);
            setTimeout(() => syncMainPriceFromFormVariant(root, form, productJson, 'id-change-delayed'), 120);
          },
          true
        );
      }

      root.addEventListener(
        'click',
        function (e) {
          if (e.target.closest('.new-form-option')) {
            if (e.isTrusted === true) {
              keepInitialSinglePrice = false;
              root.dataset.initialSinglePriceUnlocked = '1';
            }
            const b = (bundleHidden && bundleHidden.value) || currentBundle || 'single';
            setTimeout(() => syncMainPriceFromOffer(root, b), 0);
            setTimeout(() => syncMainPriceFromOffer(root, b), 120);
            if (!keepInitialSinglePrice)
              setTimeout(
                () => syncMainPriceFromFormVariant(root, form, productJson, 'new-form-option-click'),
                180
              );
          }
        },
        true
      );

      root.addEventListener(
        'change',
        function (e) {
          if (
            e.target &&
            e.target.matches &&
            (e.target.matches('.new-form-option select, .new-form-option input[type="radio"]') ||
              e.target.matches('input[name="id"], select[name="id"]'))
          ) {
            if (e.isTrusted === true) {
              keepInitialSinglePrice = false;
              root.dataset.initialSinglePriceUnlocked = '1';
            }
            const b = (bundleHidden && bundleHidden.value) || currentBundle || 'single';
            setTimeout(() => syncMainPriceFromOffer(root, b), 0);
            setTimeout(() => syncMainPriceFromOffer(root, b), 120);
          }
        },
        true
      );
    }

    const source = scopedRoot.querySelector('.bra-size-picker');
    const target_size = scopedRoot.querySelector('.bundle_size');

    if (source && target_size) {
      target_size.querySelectorAll('.bra-size-picker').forEach((el) => el.remove());
      target_size.appendChild(source);
    }
    const currentBraPicker =
      scopedRoot.querySelector('.bundle_size .bra-size-picker') || scopedRoot.querySelector('.bra-size-picker');
    if (!isPopup && notice && currentBraPicker && currentBraPicker.parentElement) {
      currentBraPicker.insertAdjacentElement('afterend', notice);
    }

    const sizeLabel = document.querySelector(
      '.variant-picker__option:nth-of-type(3) .variant-picker__option-info .h-stack span'
    );
    const bundleSizeTarget = document.querySelector('.bundle-items__size');
    if (sizeLabel && bundleSizeTarget) {
      bundleSizeTarget.textContent = sizeLabel.textContent;

      const observer = new MutationObserver(() => {
        bundleSizeTarget.textContent = sizeLabel.textContent;
        syncStockNoticeAndPreorder();
      });

      observer.observe(sizeLabel, { childList: true, characterData: true, subtree: true });
    } else {
      console.warn('[BundlePicker] sizeLabel not found — size sync skipped (new selector?)');
    }

    if (idInput) {
      idInput.addEventListener('change', syncStockNoticeAndPreorder, true);
    }
    if (form) {
      form.addEventListener('variant:change', syncStockNoticeAndPreorder, true);
    }
    const braContainer =
      scopedRoot.querySelector('.bra-size-picker') ||
      scopedRoot.querySelector('.bra-size-dropdowns') ||
      scopedRoot;
    const combinedSizeInput =
      braContainer.querySelector('#combined-size') ||
      braContainer.querySelector('input[name="options[Größe]"]') ||
      braContainer.querySelector('input[name="options[Size]"]');
    const bandSelect = braContainer.querySelector('#bra-band');
    const cupSelect = braContainer.querySelector('#bra-cup');
    const markSizeChosenByUser = function (ev) {
      if (ev && ev.isTrusted !== true) return;
      combinedSizeChosenByUser = true;
      setTimeout(syncStockNoticeAndPreorder, 0);
    };
    if (combinedSizeInput) {
      combinedSizeInput.addEventListener('change', markSizeChosenByUser, true);
      combinedSizeInput.addEventListener('input', markSizeChosenByUser, true);
    }
    if (bandSelect) bandSelect.addEventListener('change', markSizeChosenByUser, true);
    if (cupSelect) cupSelect.addEventListener('change', markSizeChosenByUser, true);

    const submitBtnWatch =
      scopedRoot.querySelector('.product-info__buy-buttons buy-buttons button[type="submit"]') ||
      scopedRoot.querySelector('.product-info__buy-buttons button[type="submit"]') ||
      document.querySelector('.product-info__buy-buttons buy-buttons button[type="submit"]');
    if (submitBtnWatch && window.MutationObserver) {
      const atcObserver = new MutationObserver(() => {
        const inactive = submitBtnWatch.disabled || submitBtnWatch.getAttribute('aria-disabled') === 'true';
        if (inactive) renderNotice('', '');
        else syncStockNoticeAndPreorder();
      });
      atcObserver.observe(submitBtnWatch, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }

    // Recompute stock/preorder when ANY combo color row changes (not just row 0).
    root.addEventListener('bundle:colorchange', () => setTimeout(syncStockNoticeAndPreorder, 0));

    // Always hidden initially until ATC activation + valid size flow.
    renderNotice('', '');
    setTimeout(syncStockNoticeAndPreorder, 0);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.bundle-picker').forEach(init);
  });

  function onPopupVariantChange(form) {
    if (!form) return;
    const modal = form.closest('.product-popup-modal');
    if (!modal) return;
    const picker = modal.querySelector('.bundle-picker[data-popup="true"]');
    if (!picker) return;
    const bundle = picker.querySelector('input[name="properties[_bundle]"]')?.value || 'single';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => updatePopupPriceForBundle(picker, bundle));
    });
  }

  document.addEventListener(
    'variant:change',
    function (e) {
      if (e.target && e.target.tagName === 'FORM') onPopupVariantChange(e.target);
    },
    true
  );
  document.addEventListener(
    'change',
    function (e) {
      if (!e.target || !e.target.matches || !e.target.matches('input[name="id"]')) return;
      const form = e.target.form || e.target.closest('form');
      onPopupVariantChange(form);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const label = e.target.closest('.popup-variant__label');
      if (!label || label.classList.contains('popup-variant__label--disabled')) return;
      const picker = label.closest('.bundle-picker[data-popup="true"]');
      if (!picker) return;
      setTimeout(function () {
        const bundle = picker.querySelector('input[name="properties[_bundle]"]')?.value || 'single';
        const productJson = getProductJson(picker);
        const form = findProductForm(picker);
        const sizeName = (label.textContent || '').trim();
        const colorsEl = picker.querySelector('.bundle-items__colors');
        const colorName = colorsEl ? (colorsEl.textContent || '').split(/[,&]/)[0].trim() : null;
        const variant =
          productJson && sizeName && findVariantByOfferSizeColor(productJson, bundle, sizeName, colorName);
        if (variant && form) {
          const idInput = form.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = String(variant.id);
            setVariantInUrl(variant.id);
          }
          const submitBtn = form.querySelector('buy-buttons button[type="submit"], buy-buttons [type="submit"]');
          if (submitBtn) {
            const available = variant.available !== false;
            const variantRoot = picker.querySelector('[data-popup-variant]');
            const addText = (variantRoot && variantRoot.getAttribute('data-add-to-cart')) || 'Add to cart';
            const soldOutText = (variantRoot && variantRoot.getAttribute('data-sold-out')) || 'Sold out';
            submitBtn.disabled = !available;
            submitBtn.setAttribute('aria-disabled', String(!available));
            submitBtn.textContent = available ? addText : soldOutText;
            submitBtn.classList.toggle('button--subdued', !available);
          }
        }
        updatePopupPriceForBundle(picker, bundle);
      }, 0);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const swatch = e.target.closest('.bundle-fixed-swatch');
      if (!swatch || swatch.classList.contains('bundle-fixed-swatch--disabled') || swatch.disabled) return;
      const picker = swatch.closest('.bundle-picker[data-popup="true"]');
      if (!picker) return;
      const colorCombo =
        swatch.dataset.comboId ||
        swatch.dataset.color ||
        (swatch.querySelector('.bundle-fixed-swatch__label') &&
          swatch.querySelector('.bundle-fixed-swatch__label').textContent.trim()) ||
        '';
      if (!colorCombo) return;
      const bundle = picker.querySelector('input[name="properties[_bundle]"]')?.value || 'single';
      const productJson = getProductJson(picker);
      const form = findProductForm(picker);
      if (!productJson || !form) return;
      const variantRoot = picker.querySelector('[data-popup-variant]');
      const selectedLabel = variantRoot && variantRoot.querySelector('.popup-variant__label--selected');
      const sizeName = selectedLabel
        ? (selectedLabel.textContent || '').trim()
        : (picker.querySelector('.bundle-items__size') &&
            (picker.querySelector('.bundle-items__size').textContent || '').trim()) ||
          '';
      const variant = findVariantByOfferSizeColor(productJson, bundle, sizeName, colorCombo);
      if (variant) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = String(variant.id);
          setVariantInUrl(variant.id);
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const submitBtn = form.querySelector('buy-buttons button[type="submit"], buy-buttons [type="submit"]');
        if (submitBtn) {
          const available = variant.available !== false;
          const variantRoot = picker.querySelector('[data-popup-variant]');
          const addText = (variantRoot && variantRoot.getAttribute('data-add-to-cart')) || 'Add to cart';
          const soldOutText = (variantRoot && variantRoot.getAttribute('data-sold-out')) || 'Sold out';
          submitBtn.disabled = !available;
          submitBtn.setAttribute('aria-disabled', String(!available));
          submitBtn.textContent = available ? addText : soldOutText;
          submitBtn.classList.toggle('button--subdued', !available);
        }
        const colorsHeader = picker.querySelector('.bundle-items__colors');
        if (colorsHeader)
          colorsHeader.textContent = swatch.querySelector('.bundle-fixed-swatch__label')
            ? swatch.querySelector('.bundle-fixed-swatch__label').textContent.trim()
            : colorCombo;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          updatePopupPriceForBundle(picker, bundle);
        });
      });
    },
    true
  );

  document.addEventListener('product-popup-opened', function (e) {
    const modal = (e.detail && e.detail.modal) || e.target;
    if (!modal || !modal.classList || !modal.classList.contains('product-popup-modal')) return;
    const picker = modal.querySelector('.bundle-picker[data-popup="true"]');
    if (!picker) return;
    const bundleHidden = picker.querySelector('input[name="properties[_bundle]"]');
    if (bundleHidden) bundleHidden.value = 'one_plus_one';
    const cards = picker.querySelectorAll('.bundle-card');
    cards.forEach((c) => c.setAttribute('aria-checked', c.dataset.bundle === 'one_plus_one' ? 'true' : 'false'));
    updateUnlockUI(picker, 'one_plus_one');
    renderItems(picker, 'one_plus_one');
    applyPopupSizeFilter(picker, 'one_plus_one');
    const form = findProductForm(picker);
    const productJson = getProductJson(picker);
    const firstVariant =
      productJson &&
      (getFirstAvailableVariantForOffer(productJson, 'one_plus_one') ||
        getFirstAvailableVariantForOffer(productJson, 'single') ||
        (productJson.variants && productJson.variants.find((v) => v.available)));
    if (firstVariant && form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = String(firstVariant.id);
    } else if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = '';
    }
    setVariantInUrl(null);
    const variantRoot = picker.querySelector('[data-popup-variant]');
    if (variantRoot && firstVariant) {
      const radio = variantRoot.querySelector(
        'input[type="radio"][data-variant-id="' + String(firstVariant.id) + '"]'
      );
      if (radio && !radio.disabled) {
        radio.checked = true;
        variantRoot.querySelectorAll('.popup-variant__label').forEach(function (l) {
          l.classList.remove('popup-variant__label--selected');
        });
        const label = variantRoot.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
        if (label) label.classList.add('popup-variant__label--selected');
        const legend = variantRoot.querySelector('.popup-variant__legend');
        if (legend && label) {
          const optName = variantRoot.getAttribute('data-option-name') || 'Größe';
          legend.textContent = optName + ': ' + (label.textContent || '').trim();
        }
      }
      if (form) {
        const submitBtn = form.querySelector('buy-buttons button[type="submit"], buy-buttons [type="submit"]');
        if (submitBtn) {
          const available = firstVariant.available !== false;
          const addText = (variantRoot && variantRoot.getAttribute('data-add-to-cart')) || 'Add to cart';
          const soldOutText = (variantRoot && variantRoot.getAttribute('data-sold-out')) || 'Sold out';
          submitBtn.disabled = !available;
          submitBtn.setAttribute('aria-disabled', String(!available));
          submitBtn.textContent = available ? addText : soldOutText;
          submitBtn.classList.toggle('button--subdued', !available);
        }
      }
    } else if (form && firstVariant) {
      const submitBtn = form.querySelector('buy-buttons button[type="submit"], buy-buttons [type="submit"]');
      if (submitBtn) {
        const available = firstVariant.available !== false;
        submitBtn.disabled = !available;
        submitBtn.setAttribute('aria-disabled', String(!available));
        submitBtn.classList.toggle('button--subdued', !available);
      }
    }
    triggerCheckedVariantChange(picker);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        updatePopupPriceForBundle(picker, 'one_plus_one');
        syncPopupFormSubmitButton(picker, form, productJson);
        triggerCheckedVariantChange(picker);
        setTimeout(function () {
          syncPopupFormSubmitButton(picker, form, productJson);
          triggerCheckedVariantChange(picker);
        }, 80);
      });
    });
  });

  document.addEventListener('product:rerender', function (e) {
    const form = e.target && e.target.id && typeof e.target.id === 'string' ? e.target : null;
    if (!form || !form.id || form.id.indexOf('upsell-product-form-') !== 0) return;
    const modal = form.closest && form.closest('.product-popup-modal.is-open');
    if (!modal) return;
    const picker = modal.querySelector('.bundle-picker[data-popup="true"]');
    if (!picker) return;
    const productJson = getProductJson(picker);
    requestAnimationFrame(function () {
      syncPopupFormSubmitButton(picker, form, productJson);
      triggerCheckedVariantChange(picker);
    });
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-open-size-chart]');
    if (!trigger) return;
    if (e.__rosSizeChartHandled) return;
    e.__rosSizeChartHandled = true;

    const drawerId = trigger.getAttribute('aria-controls');
    if (drawerId) {
      e.preventDefault();
      e.stopPropagation();

      const scopedRoot =
        trigger.closest('.product-popup-modal') || trigger.closest('.shopify-section') || document;
      const escapedId = window.CSS && CSS.escape ? CSS.escape(drawerId) : drawerId;
      const drawer = scopedRoot.querySelector('#' + escapedId) || document.getElementById(drawerId);

      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
        return;
      }
      if (drawer) {
        drawer.setAttribute('open', '');
        return;
      }
      return;
    }

    const target = document.querySelector('.size-new-pdp');
    if (target) target.click();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const bandMain = document.getElementById('bra-band');
    const cupMain = document.getElementById('bra-cup');

    function syncToActiveBundle() {
      const active = document.querySelector('.new-form-option.selectedWB');
      if (!active) return;

      const bandTarget = active.querySelector('.wb-band');
      const cupTarget = active.querySelector('.wb-cup');

      if (!bandTarget || !cupTarget) return;

      // ---------- BAND (works already) ----------
      bandTarget.value = bandMain.value || '';
      bandTarget.dispatchEvent(new Event('change', { bubbles: true }));

      // ---------- CUP (fixed logic) ----------
      const cupValue = cupMain.value;

      if (cupValue) {
        const match = Array.from(cupTarget.options).find(
          (o) => o.value === cupValue || o.textContent.trim() === cupValue
        );

        if (match) {
          cupTarget.value = match.value;
          cupTarget.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          console.warn('Cup not found in bundle:', cupValue);
        }
      }
    }

    bandMain.addEventListener('change', syncToActiveBundle);
    cupMain.addEventListener('change', syncToActiveBundle);

    document.addEventListener('click', function (e) {
      const card = e.target.closest('.new-form-option');
      if (!card) return;

      setTimeout(syncToActiveBundle, 50);
    });
  });
})();
